<template>
  <div style="background:#FAFAFA;" class="policeLato">

    <!--PARITE HEADER AVEC IMAGES AVEC PARALAX DE L'IMAGE-->
    <section class="mt-5 pt-5" v-if="isDesktop()">
      <div class="paralax-cover-image has-background-dim">
        <p class="paralax-cover-image-text">
          <div class="content_home" style="z-index: 1!important">
            <h1 style="font-size: 70px" class="font-weight-bold"><span style="color: #fff">Individuel</span></h1>
            <h1 style="font-size: 70px;margin-top: -30px" class="font-weight-bold"><span style="color: #ffa409" class="ml-1">Accident</span></h1>
          </div>
        </p>
      </div>
    </section>

    <!--PARITE HEADER AVEC IMAGES AVEC PARALAX DE L'IMAGE-->
    <section class="mt-5" v-if="isMobile()">
      <div class="paralax-cover-image_mobile has-background-dim_mobile">
        <div class="paralax-cover-image-text_mobile">
          <div class="content_home" style="z-index: 1!important;margin-top: 25%">
            <h1 style="font-size: 40px" class="font-weight-bold"><span style="color: #fff">Individuel</span></h1>
            <h1 style="font-size: 40px;margin-top: -20px;color: #ffa409" class="font-weight-bold"><span>Accident</span></h1>
          </div>
        </div>
      </div>
    </section>

    <div>
      <div class="container" style="background:#FAFAFA">
        <div class="container justify-content-center row text-center mb-5 mt-5">
          <p class="mb-3" style="font-weight: 300;color: #ffa409;font-family: Open Sans, sans-serif;font-size:25px!important;">Votre <span class="font-weight-bold">devis gratuit</span> en 2 minutes et <span class="font-weight-bold">100% en ligne</span></p> <br>
        </div>
        <br>


        <div class="row" style="background:#FAFAFA" v-if="isDesktop()">
          <div class="col-md-10 offset-1" style="background:#FAFAFA">
            <div class="form" style="background:#FAFAFA">
              <div class="wizard-navigation">
                <div class="wizard-progress-with-circle">
                  <div class="wizard-progress-bar" style="background-color: rgb(231, 76, 60); color: rgb(231, 76, 60); width: 4.54545%;"></div>
                </div>
                <div class="progress-bar-group">
                  <div class="progress-bar-custom" id="testup"></div>
                </div>
                <ul role="tablist" class="wizard-nav wizard-nav-pills">
                  <li class="step" id="firstStep">
                    <div class="step-title">Profil</div>
                  </li>
                  <li class="step" id="secondStep">
                    <div class="step-title">Garantie(s)</div>
                  </li>
                  <li class="step" id="thirstStep">
                    <div class="step-title">Souscripteur</div>
                  </li>
                  <li class="step" id="fourStep">
                    <div class="step-title">Validation</div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div class="row" style="background:#FAFAFA" v-if="isMobile()">
          <div class="col-md-10" style="background:#FAFAFA">
            <div class="form" style="background:#FAFAFA">
              <div class="wizard-navigation">
                <div class="wizard-progress-with-circle">
                  <div class="wizard-progress-bar" style="background-color: rgb(231, 76, 60); color: rgb(231, 76, 60); width: 4.54545%;"></div>
                </div>
                <div class="progress-bar-group">
                  <div class="progress-bar-custom" id="testup"></div>
                </div>
                <ul role="tablist" class="wizard-nav wizard-nav-pills">
                  <li class="step" id="firstStep">
                    <div class="step-title"></div>
                  </li>
                  <li class="step" id="secondStep">
                    <div class="step-title"></div>
                  </li>
                  <li class="step" id="thirstStep">
                    <div class="step-title"></div>
                  </li>
                  <li class="step" id="fourStep">
                    <div class="step-title"></div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <!-- ===================    DEBUT DE LA PARTIE UNIQUEMENT POUR LE DESKTOP      =============== -->
        <!-- =                      SACHANT QUE LE CODE EST ASSEZ LONG, IL CONVIENT                  = -->
        <!-- =                      DE BIEN INDENTER LE CODE POUR UNE BONNE LISIBILITE               = -->
        <!-- ========================================================================================= -->
        <div v-responsive.lg.xl class="mt-5 row" style="background:#FAFAFA">
          <div class="col-md-10 offset-1" style="background:#FAFAFA">
            <div class="form" style="background:#FAFAFA">
              <div class="page" v-show="step === 1">
                <div class="wizard-tab-content">
                  <div role="tabpanel" id="Step1" aria-labelledby="step-Step1" class="wizard-tab-container">
                    <div>
                      <div class="fields">
                        <section class="section-sm-bottom-85">
                          <div class="container mt-1">
                            <div class="row gx-xxl-6">
                              <aside class="col-12 col-lg-4">
                                <div id="sidebar" class="c-sidebar" data-toggle="affix">
                                  <div class="c-cta-block" style="background-color: #fff!important">
                                    <div class="wizard-tab-content">
                                      <div role="tabpanel" id="Step1" aria-labelledby="step-Step1" class="wizard-tab-container">
                                          <div class="healthCard-product" style="box-shadow: 9px 12px 18px rgb(0 0 0 / 0%);">
                                            <div class="healthCard-img"><img src="../assets/img/img-sante/classe1.jpg" alt="classe un" class="img-responsive" /></div>
                                            <div class="healthCard-text">
                                              <div class="description-prod">
                                                <p class="font-weight-bold"><span style="color: #ffa409">Exemple :<br></span>Employé bureau</p>
                                              </div>
                                            </div>
                                          </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </aside>

                              <div class="col-12 col-lg-8" id="testResize" >
                                <div class="row">
                                  <div class="col-12">
                                    <div class="post">
                                      <div class="post-body">
                                        <div>
                                          <div class="articleContent s-post page-h2 page-h3" style="margin-top:60px;border-radius: 15px!important;box-shadow: 9px 12px 18px rgba(0, 0, 0, .2)">
                                            <div class="form">
                                              <div class="page">
                                                <div class="wizard-tab-content" style="margin-top: -30px">
                                                  <div role="tabpanel" id="Step1for" aria-labelledby="step-Step1for" class="wizard-tab-container">
                                                    <div>
                                                      <div class="fields">
                                                        <div class="row">
                                                          <ul>
                                                            <li class="font-weight-bold" style="list-style: none;font-size: 30px">Détails</li>
                                                            <li class="font-weight-bold" style="list-style: none;color:#ffa409;font-size: 20px">Description</li>
                                                            <li>{{ metierClasses[0].description  }}</li>
                                                            <br>
                                                            <li class="font-weight-bold" style="list-style: none;color:#ffa409;font-size: 20px">Profession</li>
                                                            <li>{{ metierClasses[0].profession[0] }}</li>
                                                            <li>{{ metierClasses[0].profession[1] }}</li>
                                                            <li>{{ metierClasses[0].profession[2] }}</li>
                                                            <li>{{ metierClasses[0].profession[3] }}</li>
                                                          </ul>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>

                                                <div class="wizard-card-footer clearfix" style="margin-top: -20px">
                                                  <div class="wizard-footer-left">
                                                  </div>
                                                  <div class="wizard-footer-right">
                                                    <button @click="getFirstClasse()" type="button" class="wizard-btn">
                                                      Je choisis
                                                    </button>
                                                  </div>
                                                  <!---->
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </section>
                      </div>

                      <div class="fields">
                        <section class="section-sm-bottom-85">
                          <div class="container mt-1">
                            <div class="row gx-xxl-6">
                              <aside class="col-12 col-lg-4">
                                <div id="sidebar" class="c-sidebar" data-toggle="affix">
                                  <div class="c-cta-block" style="background-color: #fafafa!important">
                                    <div class="wizard-tab-content">
                                      <div role="tabpanel" id="Step1" aria-labelledby="step-Step1" class="wizard-tab-container">
                                        <div class="healthCard-product" style="box-shadow: 9px 12px 18px rgb(0 0 0 / 0%);">
                                          <div class="healthCard-img"><img src="../assets/img/img-sante/classe2.jpg" alt="classe deux" class="img-responsive" /></div>
                                          <div class="healthCard-text">
                                            <div class="description-prod">
                                              <p class="font-weight-bold"><span style="color: #ffa409">Exemple :<br></span>Employé bureau + Manuel</p>
                                            </div>
                                          </div>
                                        </div>

                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </aside>

                              <div class="col-12 col-lg-8" id="testResize">
                                <div class="row">
                                  <div class="col-12">
                                    <div class="post">
                                      <div class="post-body">
                                        <div>
                                          <div class="articleContent s-post page-h2 page-h3" style="margin-top:60px;border-radius: 15px!important;box-shadow: 9px 12px 18px rgba(0, 0, 0, .2)">
                                            <div class="form">
                                              <div class="page">
                                                <div class="wizard-tab-content" style="margin-top: -30px">
                                                  <div role="tabpanel" id="Step1for" aria-labelledby="step-Step1for" class="wizard-tab-container">
                                                    <div>
                                                      <div class="fields">
                                                        <div class="row">
                                                          <ul>
                                                            <li class="font-weight-bold" style="list-style: none;font-size: 30px">Détails</li>
                                                            <li class="font-weight-bold" style="list-style: none;color:#ffa409;font-size: 20px">Description</li>
                                                            <li>{{ metierClasses[1].description  }}</li>
                                                            <br>
                                                            <li class="font-weight-bold" style="list-style: none;color:#ffa409;font-size: 20px">Profession</li>
                                                            <li>{{ metierClasses[1].profession[0] }}</li>
                                                            <li>{{ metierClasses[1].profession[1] }}</li>
                                                            <li>{{ metierClasses[1].profession[2] }}</li>
                                                          </ul>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>

                                                <div class="wizard-card-footer clearfix" style="margin-top: -20px">
                                                  <div class="wizard-footer-left">
                                                  </div>
                                                  <div class="wizard-footer-right">
                                                    <button @click="getSecondClasse()" type="button" class="wizard-btn">
                                                      Je choisis
                                                    </button>
                                                  </div>
                                                  <!---->
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </section>
                      </div>

                      <div class="fields">
                        <section class="section-sm-bottom-85">
                          <div class="container mt-1">
                            <div class="row gx-xxl-6">
                              <aside class="col-12 col-lg-4">
                                <div id="sidebar" class="c-sidebar" data-toggle="affix">
                                  <div class="c-cta-block" style="background-color: #fafafa!important">
                                    <div class="wizard-tab-content">
                                      <div role="tabpanel" id="Step1" aria-labelledby="step-Step1" class="wizard-tab-container">
                                        <div class="healthCard-product" style="box-shadow: 9px 12px 18px rgb(0 0 0 / 0%);">
                                          <div class="healthCard-img"><img src="../assets/img/img-sante/classe3.jpg" alt="classe trois" class="img-responsive" /></div>
                                          <div class="healthCard-text">
                                            <div class="description-prod">
                                              <p class="font-weight-bold"><span style="color: #ffa409">Exemple :<br></span>Artisans/Entrepreneur + Livraison</p>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </aside>

                              <div class="col-12 col-lg-8" id="testResize">
                                <div class="row">
                                  <div class="col-12">
                                    <div class="post">
                                      <div class="post-body">
                                        <div>
                                          <div class="articleContent s-post page-h2 page-h3" style="margin-top:60px;border-radius: 15px!important;box-shadow: 9px 12px 18px rgba(0, 0, 0, .2)">
                                            <div class="form">
                                              <div class="page">
                                                <div class="wizard-tab-content" style="margin-top: -30px">
                                                  <div role="tabpanel" id="Step1for" aria-labelledby="step-Step1for" class="wizard-tab-container">
                                                    <div>
                                                      <div class="fields">
                                                        <div class="row">
                                                          <ul>
                                                            <li class="font-weight-bold" style="list-style: none;font-size: 30px">Détails</li>
                                                            <li class="font-weight-bold" style="list-style: none;color:#ffa409;font-size: 20px">Description</li>
                                                            <li>{{ metierClasses[2].description  }}</li>
                                                            <br>
                                                            <li class="font-weight-bold" style="list-style: none;color:#ffa409;font-size: 20px">Profession</li>
                                                            <li>{{ metierClasses[2].profession[0] }}</li>
                                                            <li>{{ metierClasses[2].profession[1] }}</li>
                                                            <li>{{ metierClasses[2].profession[2] }}</li>
                                                            <li>{{ metierClasses[2].profession[3] }}</li>
                                                          </ul>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                                <div class="wizard-card-footer clearfix" style="margin-top: -20px">
                                                  <div class="wizard-footer-left">
                                                  </div>
                                                  <div class="wizard-footer-right">
                                                    <button @click="getThirstClasse()" type="button" class="wizard-btn">
                                                      Je choisis
                                                    </button>
                                                  </div>
                                                  <!---->
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </section>
                      </div>

                      <div class="fields">
                        <section class="section-sm-bottom-85">
                          <div class="container mt-1">
                            <div class="row gx-xxl-6">
                              <aside class="col-12 col-lg-4">
                                <div id="sidebar" class="c-sidebar" data-toggle="affix">
                                  <div class="c-cta-block" style="background-color: #fafafa!important">
                                    <div class="wizard-tab-content">
                                      <div role="tabpanel" id="Step1" aria-labelledby="step-Step1" class="wizard-tab-container">
                                        <div class="healthCard-product" style="box-shadow: 9px 12px 18px rgb(0 0 0 / 0%);">
                                          <div class="healthCard-img"><img src="../assets/img/img-sante/classe4.jpg" alt="classe quatre" class="img-responsive" /></div>
                                          <div class="healthCard-text">
                                            <div class="description-prod">
                                              <p class="font-weight-bold"><span style="color: #ffa409">Exemple :<br></span>Travailleurs industrie/Transport</p>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </aside>

                              <div class="col-12 col-lg-8" id="testResize">
                                <div class="row">
                                  <div class="col-12">
                                    <div class="post">
                                      <div class="post-body">
                                        <div>
                                          <div class="articleContent s-post page-h2 page-h3" style="margin-top:60px;border-radius: 15px!important;box-shadow: 9px 12px 18px rgba(0, 0, 0, .2)">
                                            <div class="form">
                                              <div class="page">
                                                <div class="wizard-tab-content" style="margin-top: -30px">
                                                  <div role="tabpanel" id="Step1for" aria-labelledby="step-Step1for" class="wizard-tab-container">
                                                    <div>
                                                      <div class="fields">
                                                        <div class="row">
                                                          <ul>
                                                            <li class="font-weight-bold" style="list-style: none;font-size: 30px">Détails</li>
                                                            <li class="font-weight-bold" style="list-style: none;color:#ffa409;font-size: 20px">Description</li>
                                                            <li>{{ metierClasses[3].description  }}</li>
                                                            <br>
                                                            <li class="font-weight-bold" style="list-style: none;color:#ffa409;font-size: 20px">Profession</li>
                                                            <li>{{ metierClasses[3].profession[0] }}</li>
                                                            <li>{{ metierClasses[3].profession[1] }}</li>
                                                            <li>{{ metierClasses[3].profession[2] }}</li>
                                                            <li>{{ metierClasses[3].profession[3] }}</li>
                                                          </ul>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>

                                                <div class="wizard-card-footer clearfix" style="margin-top: -20px">
                                                  <div class="wizard-footer-left">
                                                  </div>
                                                  <div class="wizard-footer-right">
                                                    <button @click="getFourthClasse()" type="button" class="wizard-btn">
                                                      Je choisis
                                                    </button>
                                                  </div>
                                                  <!---->
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </section>
                      </div>

                      <div class="fields">
                        <section class="section-sm-bottom-85">
                          <div class="container mt-1">
                            <div class="row gx-xxl-6">
                              <aside class="col-12 col-lg-4">
                                <div id="sidebar" class="c-sidebar" data-toggle="affix">
                                  <div class="c-cta-block" style="background-color: #fafafa!important">
                                    <div class="wizard-tab-content">
                                      <div role="tabpanel" id="Step1" aria-labelledby="step-Step1" class="wizard-tab-container">
                                        <div class="healthCard-product" style="box-shadow: 9px 12px 18px rgb(0 0 0 / 0%);">
                                          <div class="healthCard-img"><img src="../assets/img/img-sante/classe5.jpg" alt="classe cinq" class="img-responsive" /></div>
                                          <div class="healthCard-text">
                                            <div class="description-prod">
                                              <p class="font-weight-bold"><span style="color: #ffa409">Exemple :<br></span>Travaux construction, montage, docks/Entrepots</p>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </aside>

                              <div class="col-12 col-lg-8" id="testResize">
                                <div class="row">
                                  <div class="col-12">
                                    <div class="post">
                                      <div class="post-body">
                                        <div>
                                          <div class="articleContent s-post page-h2 page-h3" style="margin-top:60px;border-radius: 15px!important;box-shadow: 9px 12px 18px rgba(0, 0, 0, .2)">
                                            <div class="form">
                                              <div class="page">
                                                <div class="wizard-tab-content" style="margin-top: -30px">
                                                  <div role="tabpanel" id="Step1for" aria-labelledby="step-Step1for" class="wizard-tab-container">
                                                    <div>
                                                      <div class="fields">
                                                        <div class="row">
                                                          <ul>
                                                            <li class="font-weight-bold" style="list-style: none;font-size: 30px">Détails</li>
                                                            <li class="font-weight-bold" style="list-style: none;color:#ffa409;font-size: 20px">Description</li>
                                                            <li>{{ metierClasses[4].description  }}</li>
                                                            <br>
                                                            <li class="font-weight-bold" style="list-style: none;color:#ffa409;font-size: 20px">Profession</li>
                                                            <li>{{ metierClasses[4].profession[0] }}</li>
                                                            <li>{{ metierClasses[4].profession[1] }}</li>
                                                            <li>{{ metierClasses[4].profession[2] }}</li>
                                                            <li>{{ metierClasses[4].profession[3] }}</li>
                                                            <li>{{ metierClasses[4].profession[4] }}</li>
                                                            <li>{{ metierClasses[4].profession[5] }}</li>
                                                            <li>{{ metierClasses[4].profession[6] }}</li>
                                                            <li>{{ metierClasses[4].profession[7] }}</li>
                                                            <li>{{ metierClasses[4].profession[8] }}</li>
                                                            <li>{{ metierClasses[4].profession[9] }}</li>
                                                            <li>{{ metierClasses[4].profession[10] }}</li>
                                                            <li>{{ metierClasses[4].profession[11] }}</li>
                                                            <li>{{ metierClasses[4].profession[12] }}</li>
                                                          </ul>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>

                                                <div class="wizard-card-footer clearfix" style="margin-top: -20px">
                                                  <div class="wizard-footer-left">
                                                  </div>
                                                  <div class="wizard-footer-right">
                                                    <button @click="getFiveClasse()" type="button" class="wizard-btn">
                                                      Je choisis
                                                    </button>
                                                  </div>
                                                  <!---->
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </section>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="page" v-show="step === 2">
                <div class="wizard-tab-content">
                  <div role="tabpanel" id="Step1" aria-labelledby="step-Step1" class="wizard-tab-container">
                    <div>
                      <div class="fields">
                        <section class="section-sm-bottom-85">
                          <div class="container mt-1">
                            <div class="row gx-xxl-6">
                              <div class="col-12 col-lg-12" id="testResize" >
                                <div class="row">
                                  <div class="col-12">
                                    <div class="post">
                                      <div class="post-body">
                                        <div>
                                          <div class="articleContent s-post page-h2 page-h3" style="margin-top:60px;border-radius: 15px!important;box-shadow: 9px 12px 18px rgba(0, 0, 0, .2)">
                                            <div class="form">
                                              <div class="page">
                                                <div class="wizard-tab-content" style="margin-top: -30px">
                                                  <div role="tabpanel" id="Step1for" aria-labelledby="step-Step1for" class="wizard-tab-container">
                                                    <div class="fields">
                                                      <div class="field-title font-weight-bold">Choix&nbsp;:</div>
                                                      <div class="field-group justify-content-center row flex-column flex-sm-row">
                                                        <div class="btn-choice btn-choice-icon sm-no-change">
                                                          <input v-model="garanties" value="DECES" type="checkbox" id="Deces" name="Step1" @change="garantiesValidator" class="field-input">
                                                          <label for="Deces" class="flex-row flex-md-column field-label">
                                                            <img src="../assets/img/icones/deces.png" alt="deces" class="mr-4 mr-md-0">
                                                            <p class="text-center">
                                                              <span class="tool" data-tip="Versement d’un capital en cas de Décè." tabindex="1">Décès</span>
                                                            </p>
                                                          </label>
                                                        </div>
                                                        <div class="btn-choice btn-choice-icon sm-no-change ml-4">
                                                          <input v-model="garanties" type="checkbox" value="INVALIDITE PERMANENTE" id="invalidite" name="Step1" @change="garantiesValidator" class="field-input">
                                                          <label for="invalidite" class="flex-row flex-md-column field-label">
                                                            <img src="../assets/img/icones/permanent.png" alt="permanent" class="mr-4 mr-md-0">
                                                            <p class="text-center">
                                                              <span class="tool" data-tip="Versement d’un capital en cas d’invalidité permanente." tabindex="1">Invalidité Permanente</span>
                                                            </p>
                                                          </label>
                                                        </div>
                                                        <div class="btn-choice btn-choice-icon sm-no-change ml-4">
                                                          <input v-model="garanties" type="checkbox" value="INCAPACITE TEMPORAIRE" id="Incapacite" name="Step1" @change="garantiesValidator" class="field-input">
                                                          <label for="Incapacite" class="flex-row flex-md-column field-label">
                                                            <img src="../assets/img/icones/temporaire.png" alt="temporaire" class="mr-4 mr-md-0">
                                                            <p class="text-center">
                                                              <span class="tool" data-tip="Versement d’une bourse journalière à hauteur du montant choisi partir du 16eme jours d’incapacité." tabindex="1">Incapacité Temporaire</span>
                                                            </p>
                                                          </label>
                                                        </div>
                                                        <div class="btn-choice btn-choice-icon sm-no-change ml-4">
                                                          <input v-model="garanties" type="checkbox" value="FRAIS MEDICAUX" id="frais" name="Step1" @change="garantiesValidator" class="field-input">
                                                          <label for="frais" class="flex-row flex-md-column field-label">
                                                            <img src="../assets/img/icones/frais_medicaux.png" alt="frais médicaux" class="mr-4 mr-md-0">
                                                            <p class="text-center">
                                                              <span class="tool" data-tip="Remboursement des frais à hauteur du montant choisi." tabindex="1">Frais Médicaux</span>
                                                            </p>
                                                          </label>
                                                        </div>
                                                      </div>
                                                      <div class="row">
                                                        <div class="col-sm-6" v-if="capitalValideForDeces">
                                                          <div class="field-group field-default flex-sm-row mt-5 ">
                                                            <label for="Stepper2_deces" class="field-label">Capital souhaité pour décès (En million) FCFA</label>
                                                            <select id="Stepper2_deces" v-model="capitalDeces" name="Step1" class="field-select" @change="calculPrimeForDeces">
                                                              <option v-for="item in CapitalItems" :key="item" :value="item.value">{{item.capital}}</option>
                                                            </select>
                                                          </div>
                                                        </div>

                                                        <div class="col-sm-6" v-if="capitalValideForInvalidite">
                                                          <div class="field-group field-default flex-sm-row mt-5 ">
                                                            <label for="Stepper2_invalidite" class="field-label">Capital souhaité pour invalidité (En million) FCFA</label>
                                                            <select id="Stepper2_invalidite" v-model="capitalInvalidite" name="Step1" class="field-select" @change="calculPrimeForInvalide">
                                                              <option v-for="item in CapitalItems" :key="item" :value="item.value">{{item.capital}}</option>
                                                            </select>
                                                          </div>
                                                        </div>

                                                        <div class="col-sm-6" v-if="bourseValideIncapacite">
                                                          <div class="field-group field-default flex-sm-row mt-5 ">
                                                            <label for="Stepper2_incapacite" class="field-label">Bourse incapacité temporaire FCFA</label>
                                                            <select id="Stepper2_incapacite" v-model="bourseIncapacite" name="Step1" class="field-select" @change="calculPrimeIncaTemporaire">
                                                              <option v-for="item in incapaciteItems" :key="item" :value="item">{{item}}</option>
                                                            </select>
                                                          </div>
                                                        </div>

                                                        <div class="col-sm-6" v-if="bourseValideFrais">
                                                          <div class="field-group field-default flex-sm-row mt-5 ">
                                                            <label for="Stepper2_frais" class="field-label">Remboursement frais médicaux FCFA</label>
                                                            <select id="Stepper2_frais" v-model="bourse" name="Step1" class="field-select" @change="calculPrimeFraisMedicaux">
                                                              <option v-for="item in RemboursementItems" :key="item" :value="item.bourse">{{item.bourse}}</option>
                                                            </select>
                                                          </div>
                                                        </div>
                                                      </div>

                                                      <div class="row">

                                                      </div>

                                                      <div class="justify-content-center row font-weight-bold mt-5">
                                                        <div class="justify-content-center column">
                                                          <p v-if="Prime_deces !== null" style="margin-top: -25px">Prime Décès : <span class="to-right" style="color: #ffa409">{{Prime_deces.toLocaleString()}} FCFA</span></p>
                                                          <p v-if="prime_invalidite !== null" style="margin-top: -25px">Prime invalidité : <span class="to-right" style="color: #ffa409">{{prime_invalidite.toLocaleString()}} FCFA</span></p>
                                                          <p v-if="bourseIncapaciteTemporaire !== null" style="margin-top: -25px">Prime Incapacité temporaire : <span class="to-right" style="color: #ffa409">{{bourseIncapaciteTemporaire.toLocaleString()}} FCFA</span></p>
                                                          <p v-if="bourseFraisMedicaux !== null" style="margin-top: -25px">Prime Frais médicaux : <span class="to-right" style="color: #ffa409">{{bourseFraisMedicaux.toLocaleString()}} FCFA</span></p>
                                                          <p v-if="PrimeNette !== null" style="margin-top: -25px">Prime Nette : <span class="to-right" style="color: #5B94BC">{{PrimeNette.toLocaleString()}} FCFA</span></p>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>

                                                <div class="wizard-card-footer clearfix">
                                                  <div class="wizard-footer-left">
                                                    <button @click="returToFirstStep()" type="button" class="wizard-btn">
                                                      <span class="fas fa-arrow-left"></span>
                                                      Retour
                                                    </button>
                                                  </div>
                                                  <div class="wizard-footer-right">
                                                    <button @click="stepper2Validator" type="button" class="wizard-btn">
                                                      Suivant
                                                    </button>
                                                  </div>
                                                  <!---->
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </section>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="page" v-show="step === 3">
                <div class="wizard-tab-content">
                  <div role="tabpanel" id="Step1" aria-labelledby="step-Step1" class="wizard-tab-container">
                    <div>
                      <div class="fields">
                        <section class="section-sm-bottom-85">
                          <div class="container mt-1">
                            <div class="row gx-xxl-6">
                              <div class="col-12 col-lg-12" id="testResize">
                                <div class="row">
                                  <div class="col-12">
                                    <div class="post">
                                      <div class="post-body">
                                        <div>
                                          <div class="articleContent s-post page-h2 page-h3" style="margin-top:60px;border-radius: 15px!important;box-shadow: 9px 12px 18px rgba(0, 0, 0, .2)">
                                            <div class="form">
                                              <div class="page">
                                                <div class="wizard-tab-content" style="margin-top: -30px">
                                                  <div role="tabpanel" id="Step1for" aria-labelledby="step-Step1for" class="wizard-tab-container">
                                                      <div class="fields">
                                                        <div class="field-title font-weight-bold">Souscripteur&nbsp;:</div>
                                                        <div class="mt-3 justify-content-center row">
                                                          <div class="justify-content-center row">
                                                            <p clas="field-title">Le souscripteur est-il le compte connecté ?</p>
                                                          </div>

                                                          <div class="row">
                                                            <p>
                                                              <label class="toggleSwitch nolabel mt-2">
                                                                <input :disabled="disabled_checkbox" v-model="checkbox" type="checkbox" @change="getUserDataFromStore"/>
                                                                <span>
                                                                      <span>NON</span>
                                                                      <span>OUI</span>
                                                                  </span>
                                                                <a></a>
                                                              </label>
                                                            </p>
                                                          </div>
                                                        </div>


                                                        <div class="row">
                                                          <div class="col-sm-4">
                                                            <div class="field-group field-default mb-4 mb-sm-0">
                                                              <label for="Stepper28" class="field-label">Prénom</label>
                                                              <input placeholder="Votre prénom" id="Stepper28" v-model="ContractantFields.Prenom" name="Step8" class="field-input">
                                                            </div>
                                                          </div>
                                                          <div class="col-sm-4">
                                                            <div class="field-group field-default mb-4 mb-sm-0">
                                                              <label for="Stepper28" class="field-label">Nom</label>
                                                              <input placeholder="Votre nom" id="Stepper28" v-model="ContractantFields.Nom" name="Step8" class="field-input">
                                                            </div>
                                                          </div>
                                                          <div class="col-sm-4">
                                                            <div class="field-group field-default" style="margin-top:-2px">
                                                              <label for="Stepper25" class="field-label">
                                                                Date de naissance
                                                                <!---->
                                                              </label>
                                                              <div class="input-group value-loan">
                                                                <date-picker class="field-input ml-2 mb-1 mt-1" :disabled-date="disabledAfterToday" placeholder="Cliquer ici" id="Stepper25" v-model="ContractantFields.dateNaissance" valueType="format" @change="yearsDiffContractant()" format="YYYY-MM-DD" lang="fr-fr"></date-picker>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                      <div class="fields">
                                                        <div class="row">
                                                          <div class="col-sm-6">
                                                            <div class="field-group field-default mb-4 mb-sm-0">
                                                              <label for="Stepper28" class="field-label">CNI</label>
                                                              <input @keypress="onlyNumber" placeholder="CNI" id="Stepper28" v-model="ContractantFields.Cni" name="Step8" class="field-input">
                                                            </div>
                                                          </div>
                                                          <div class="col-sm-6">
                                                            <div class="field-group field-default mb-4 mb-sm-0">
                                                              <label for="Stepper28" class="field-label">Profession</label>
                                                              <input placeholder="Votre profession" id="Stepper28" v-model="ContractantFields.Profession" name="Step8" class="field-input">
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                  </div>
                                                </div>

                                                <div class="wizard-card-footer clearfix">
                                                  <div class="wizard-footer-left">
                                                    <button @click="returToSecondStep" type="button" class="wizard-btn">
                                                      <span class="fas fa-arrow-left"></span>
                                                      Retour
                                                    </button>
                                                  </div>
                                                  <div class="wizard-footer-right">
                                                    <button @click="ContractControl" type="button" class="wizard-btn">
                                                      Suivant
                                                    </button>
                                                  </div>
                                                  <!---->
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </section>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="page" v-show="step === 4">
                <div class="wizard-tab-content">
                  <div role="tabpanel" id="Step1" aria-labelledby="step-Step1" class="wizard-tab-container">
                    <div>
                      <div class="fields">
                        <section class="section-sm-bottom-85">
                          <div class="container mt-1">
                            <div class="row gx-xxl-6">
                              <div class="col-12 col-lg-8">
                                <div class="row">
                                  <div class="col-12">
                                    <div class="post">
                                      <div class="post-body">
                                        <div>
                                          <div class="articleContent s-post page-h2 page-h3" style="margin-top:60px;border-radius: 15px!important;box-shadow: 9px 12px 18px rgba(0, 0, 0, .2)">
                                            <div class="form">
                                              <div class="page">
                                                <div class="wizard-tab-content">
                                                  <div role="tabpanel" id="Step1" aria-labelledby="step-Step1" class="wizard-tab-container">
                                                    <div class="field-title font-weight-bold">Détails de l'assurance :</div>
                                                    <div class="mt-3 justify-content-center row">
                                                      <div class="justify-content-center row">
                                                        <p class="font-weight-bold field-title" style="color: #ffa409">Souscripteur</p>
                                                      </div>
                                                    </div>
                                                    <div class="row" style="margin-top: -20px !important;background: #fafafa;border-radius: 12px;box-shadow: 0 0.5rem 1rem rgba(0,0,0,0.1);">
                                                      <div class="col-sm-12">
                                                        <div class="field-group field-default">
                                                          <ul class="to-left mb-3 mr-3 policeLato">
                                                            <li class="subheading" style="list-style: none">Prénom :
                                                              <span class="font-weight-bold to-right">{{ContractantFields.Prenom}}</span>
                                                            </li>

                                                            <li class="subheading" style="list-style: none">Nom :
                                                              <span class="font-weight-bold to-right">{{ContractantFields.Nom}}</span>
                                                            </li>

                                                            <li  class="subheading" style="list-style: none">Date de naissance :
                                                              <span class="font-weight-bold to-right">{{DateFormater(ContractantFields.dateNaissance)}}</span>
                                                            </li>

                                                            <li class="subheading" style="list-style: none">Cni :
                                                              <span class="font-weight-bold to-right">{{ContractantFields.Cni}}</span>
                                                            </li>

                                                            <li class="subheading" style="list-style: none">Profession :
                                                              <span class="font-weight-bold to-right">{{ContractantFields.Profession}}</span>
                                                            </li>
                                                          </ul>
                                                        </div>
                                                      </div>
                                                    </div>

                                                    <div class="mt-3 justify-content-center row">
                                                      <div class="justify-content-center row">
                                                        <p class="font-weight-bold field-title" style="color: #ffa409">Garanties</p>
                                                      </div>
                                                    </div>
                                                    <div class="row" style="margin-top: -20px !important;background: #fafafa;border-radius: 12px;box-shadow: 0 0.5rem 1rem rgba(0,0,0,0.1);">
                                                      <div class="col-sm-12">
                                                        <div class="field-group field-default">
                                                          <ul class="to-left mb-3 mr-3 policeLato">
                                                            <p style="margin-bottom: -3px" class="font-weight-bold">Garantie(s) choisi(s)</p>
                                                            <li class="subheading" style="list-style: none" v-for="garantie in this.garanties" :key="garantie">Nom Garantie :
                                                              <span class="font-weight-bold to-right">{{garantie}}</span>
                                                            </li>
                                                          </ul>
                                                        </div>
                                                      </div>
                                                    </div>

                                                    <div class="mt-3 justify-content-center row">
                                                      <div class="justify-content-center row">
                                                        <p class="font-weight-bold field-title" style="color: #ffa409">Détails</p>
                                                      </div>
                                                    </div>
                                                    <div class="row" style="margin-top: -20px !important;background: #fafafa;border-radius: 12px;box-shadow: 0 0.5rem 1rem rgba(0,0,0,0.1);">
                                                      <div class="col-sm-12">
                                                        <div class="field-group field-default">
                                                          <ul class="to-left mb-3 mr-3 policeLato">
                                                            <p style="margin-bottom: -3px" class="font-weight-bold mt-5">Détails des capitaux</p>
                                                            <li v-if="capitalDeces !== null" class="subheading" style="list-style: none">Capital Décès :
                                                              <span class="font-weight-bold to-right">{{capitalDeces.toLocaleString()}} FCFA</span>
                                                            </li>
                                                            <li v-if="capitalInvalidite !== null" class="subheading" style="list-style: none">Capital Invalidité :
                                                              <span class="font-weight-bold to-right">{{capitalInvalidite.toLocaleString()}} FCFA</span>
                                                            </li>
                                                            <li v-if="bourse !== null" class="subheading" style="list-style: none">Frais médicaux :
                                                              <span class="font-weight-bold to-right">{{bourse.toLocaleString()}} FCFA</span>
                                                            </li>
                                                            <li v-if="bourseIncapacite !== null" class="subheading" style="list-style: none">Incapacité temporaire :
                                                              <span class="font-weight-bold to-right">{{bourseIncapacite.toLocaleString()}} FCFA</span>
                                                            </li>
                                                          </ul>
                                                        </div>
                                                      </div>
                                                    </div>

                                                    <div class="mt-3 justify-content-center row">
                                                      <div class="justify-content-center row">
                                                        <p class="font-weight-bold field-title" style="color: #ffa409">Période de couverture</p>
                                                      </div>
                                                    </div>

                                                    <div class="row">
                                                      <div class="col-sm-6">
                                                        <div class="field-group field-default mb-4 mb-sm-0">
                                                          <label for="Stepper39" class="field-label">Date d'effet
                                                            <button type="button" tabindex="-1" title="" class="field-help" data-original-title="Taux d'intérêt"></button></label>
                                                          <div class="input-group rate-loan">
                                                            <date-picker id="Stepper39" :disabled-date="disabledBeforeToday" class="field-input ml-2 mb-1 mt-1" placeholder="Cliquer ici" @change="dateDiff()" :min="new Date().toISOString().substr(0, 10)" v-model="dateEffet" valueType="format" format="YYYY-MM-DD" lang="fr-fr"></date-picker>
                                                          </div>
                                                        </div>
                                                      </div>
                                                      <div class="col-sm-6">
                                                        <div class="field-group field-default mb-4 mb-sm-0">
                                                          <label for="Stepper40" class="field-label">Date d'échéance
                                                            <button type="button" tabindex="-1" title="" class="field-help" data-original-title="Taux d'intérêt"></button></label>
                                                          <div class="input-group rate-loan">
                                                            <input disabled placeholder="Date d'échéance" v-model="dateEcheance" id="Stepper40" name="Step11" class="field-input">
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                                <div class="wizard-card-footer clearfix mb-3">
                                                  <div class="wizard-footer-left">
                                                    <button @click="returToThirstStep()" type="button" class="wizard-btn">
                                                      <span class="fas fa-arrow-left"></span>
                                                      Retour
                                                    </button>
                                                  </div>
                                                  <div class="wizard-footer-right">
                                                    <button :disabled="disabledButtonValidate" @click="CreateDevisIndividu()" type="button" class="wizard-btn">
                                                      Valider
                                                    </button>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <aside class="col-12 col-lg-4">
                                <div id="sidebar" class="c-sidebar" data-toggle="affix">
                                  <div class="c-cta-block">
                                    <div class="c-cta-block__title font-weight-bold">Profil</div>
                                    <div class="c-cta-block__title"><span style="color:#fff!important">{{nomClasse}}</span></div>

                                    <div v-if="Prime_deces !== null" class="c-cta-block__title mt-3">Prime Décès</div>
                                    <div v-if="Prime_deces !== null" class="c-cta-block__title"><span style="color:#fff!important">{{Prime_deces.toLocaleString()}} FCFA</span></div>

                                    <div v-if="prime_invalidite !== null" class="c-cta-block__title mt-3">Prime Invalidité</div>
                                    <div v-if="prime_invalidite !== null" class="c-cta-block__title"><span style="color:#fff!important">{{prime_invalidite.toLocaleString()}} FCFA</span></div>

                                    <div v-if="bourseIncapaciteTemporaire !== null" class="c-cta-block__title mt-3">Prime Incapacité</div>
                                    <div v-if="bourseIncapaciteTemporaire !== null" class="c-cta-block__title"><span style="color:#fff!important">{{bourseIncapaciteTemporaire.toLocaleString()}} FCFA</span></div>

                                    <div v-if="bourseFraisMedicaux !== null" class="c-cta-block__title mt-3">Prime Frais médicaux</div>
                                    <div v-if="bourseFraisMedicaux !== null" class="c-cta-block__title"><span style="color:#fff!important">{{bourseFraisMedicaux.toLocaleString()}} FCFA</span></div>

                                    <div v-if="SurprimeNette !== null" class="c-cta-block__title mt-3">Surprime Totale</div>
                                    <div v-if="SurprimeNette !== null" class="c-cta-block__title"><span style="color:#fff!important">{{SurprimeNette.toLocaleString()}} FCFA</span></div>

                                    <div v-if="PrimeNette !== null" class="c-cta-block__title mt-3">Prime Nette</div>
                                    <div v-if="PrimeNette !== null" class="c-cta-block__title"><span style="color:#5B94BC!important">{{PrimeNette.toLocaleString()}} FCFA</span></div>

                                    <div v-if="frais !== null" class="c-cta-block__title mt-3">Frais</div>
                                    <div v-if="frais !== null" class="c-cta-block__title"><span style="color:#fff!important">{{frais.toLocaleString()}} FCFA</span></div>

                                    <div v-if="taxe !== null" class="c-cta-block__title mt-3">Taxe</div>
                                    <div v-if="taxe !== null" class="c-cta-block__title"><span style="color:#fff!important">{{taxe.toLocaleString()}} FCFA</span></div>

                                    <div v-if="PrimeTTC !== null" class="c-cta-block__title mt-3">Prime TTC</div>
                                    <div v-if="PrimeTTC !== null" class="c-cta-block__title"><span style="color:#5B94BC!important">{{PrimeTTC.toLocaleString()}} FCFA</span></div>
                                  </div>
                                </div>
                              </aside>
                            </div>
                          </div>
                        </section>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- ===================    DEBUT DE LA PARTIE UNIQUEMENT POUR LE MOBILE     =============== -->
        <!-- =                      SACHANT QUE LE CODE EST ASSEZ LONG, IL CONVIENT                  = -->
        <!-- =                      DE BIEN INDENTER LE CODE POUR UNE BONNE LISIBILITE               = -->
        <!-- ========================================================================================= -->
        <div v-responsive.sm.xs>
          <div class="mt-5" style="background:#FAFAFA">
            <div class="row" style="background:#FAFAFA">
              <div class="col-md-10" style="background:#FAFAFA">
                <div class="form" style="background:#FAFAFA">
                  <div class="page" v-show="step === 1">
                    <div class="wizard-tab-content">
                      <div role="tabpanel" id="Step1_mobile" aria-labelledby="step-Step1_mobile" class="wizard-tab-container">
                        <div>
                          <div class="fields">
                            <div class="field-group justify-content-center row flex-column flex-sm-row">
                              <div class="btn-choice btn-choice-icon sm-no-change">
                                <input v-model="packClasse" type="radio" value="classe_1" id="Stepper1_mobile" name="Step1_mobile" class="field-input">
                                <label for="Stepper1_mobile" class="flex-row flex-md-column field-label" style="box-shadow: 0 0.5rem 1rem rgba(0,0,0,0.1)">
                                  <img src="../assets/img/img-sante/classe1.jpg" alt="classe un" class="mr-4 mr-md-0 mt-3" style="opacity:1!important;background-color: #ffa409;box-shadow: 0 0.5rem 1rem rgba(0,0,0,0.1);border-radius: 50%;width:50px;height:50px">
                                  <h3 class="text-center field-title"><span class="font-weight-light">Profil :</span> <span class="ml-2" style="color:#ffa409">Bureau</span></h3>
                                </label>
                              </div>
                              <div class="wizard-tab-content" v-show="packClasse === 'classe_1'" style="margin-top: -5rem;">
                                <div role="tabpanel" id="text_pack_classe_1" aria-hidden="true" aria-labelledby="step-text_pack_classe_1" class="wizard-tab-container">
                                  <div>
                                    <div class="fields mt-5">
                                      <p class="field-sub-title mt-3">
                                        <br>
                                        <span class="font-weight-bold" style="color:#ffa409" @click="detailsPopup = true">Voir les détails</span>
                                      </p>
                                      <div class="wizard-footer-right mb-5">
                                        <button @click="getFirstClasse()" type="button" class="wizard-btn">
                                          Je choisis
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div class="btn-choice btn-choice-icon sm-no-change">
                                <input v-model="packClasse" type="radio" value="classe_2" id="Stepper2_mobile" name="Step1_mobile" class="field-input">
                                <label for="Stepper2_mobile" class="flex-row flex-md-column field-label" style="box-shadow: 0 0.5rem 1rem rgba(0,0,0,0.1)">
                                  <img src="../assets/img/img-sante/classe2.jpg" alt="classe deux" class="mr-4 mr-md-0 mt-3" style="opacity:1!important;background-color: #ffa409;box-shadow: 0 0.5rem 1rem rgba(0,0,0,0.1);border-radius: 50%;width:50px;height:50px">
                                  <h3 class="text-center field-title"><span class="font-weight-light">Profil :</span><span style="color:#ffa409"> Déplacements</span></h3>
                                </label>
                              </div>
                              <div class="wizard-tab-content" v-show="packClasse === 'classe_2'" style="margin-top: -5rem;">
                                <div role="tabpanel" id="text_pack_classe_2" aria-hidden="true" aria-labelledby="step-text_pack_classe_2" class="wizard-tab-container">
                                  <div>
                                    <div class="fields mt-5">
                                      <p class="field-sub-title mt-3">
                                        <br>
                                        <span class="font-weight-bold" style="color:#ffa409" @click="detailsPopup = true">Voir les détails</span>
                                      </p>
                                      <div class="wizard-footer-right mb-5">
                                        <button @click="getSecondClasse()" type="button" class="wizard-btn">
                                          Je choisis
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div class="btn-choice btn-choice-icon sm-no-change">
                                <input v-model="packClasse" type="radio" value="classe_3" id="Stepper3_mobile" name="Step1_mobile" class="field-input">
                                <label for="Stepper3_mobile" class="flex-row flex-md-column field-label" style="box-shadow: 0 0.5rem 1rem rgba(0,0,0,0.1)">
                                  <img src="../assets/img/img-sante/classe3.jpg" alt="classe trois" class="mr-4 mr-md-0 mt-3" style="opacity:1!important;background-color: #ffa409;box-shadow: 0 0.5rem 1rem rgba(0,0,0,0.1);border-radius: 50%;width:50px;height:50px">
                                  <h3 class="text-center field-title"><span class="font-weight-light">Profil :</span> <span class="ml-2" style="color:#ffa409">Artisan</span></h3>
                                </label>
                              </div>
                              <div class="wizard-tab-content" v-show="packClasse === 'classe_3'" style="margin-top: -5rem;">
                                <div role="tabpanel" id="text_pack_classe_3" aria-hidden="true" aria-labelledby="step-text_pack_classe_3" class="wizard-tab-container">
                                  <div>
                                    <div class="fields mt-5">
                                      <p class="field-sub-title mt-3">
                                        <br>
                                        <span class="font-weight-bold" style="color:#ffa409" @click="detailsPopup = true">Voir les détails</span>
                                      </p>
                                      <div class="wizard-footer-right mb-5">
                                        <button @click="getThirstClasse()" type="button" class="wizard-btn">
                                          Je choisis
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div class="btn-choice btn-choice-icon sm-no-change">
                                <input v-model="packClasse" type="radio" value="classe_4" id="Stepper4_mobile" name="Step1_mobile" class="field-input">
                                <label for="Stepper4_mobile" class="flex-row flex-md-column field-label" style="box-shadow: 0 0.5rem 1rem rgba(0,0,0,0.1)">
                                  <img src="../assets/img/img-sante/classe4.jpg" alt="classe quatre" class="mr-4 mr-md-0 mt-3" style="opacity:1!important;background-color: #ffa409;box-shadow: 0 0.5rem 1rem rgba(0,0,0,0.1);border-radius: 50%;width:50px;height:50px">
                                  <h3 class="text-center field-title"><span class="font-weight-light">Profil :</span> <span class="ml-2" style="color:#ffa409">Industrie</span></h3>
                                </label>
                              </div>
                              <div class="wizard-tab-content" v-show="packClasse === 'classe_4'" style="margin-top: -5rem;">
                                <div role="tabpanel" id="text_pack_classe_4" aria-hidden="true" aria-labelledby="step-text_pack_classe_4" class="wizard-tab-container">
                                  <div>
                                    <div class="fields mt-5">
                                      <p class="field-sub-title mt-3">
                                        <br>
                                        <span class="font-weight-bold" style="color:#ffa409" @click="detailsPopup = true">Voir les détails</span>
                                      </p>
                                      <div class="wizard-footer-right mb-5">
                                        <button @click="getFourthClasse()" type="button" class="wizard-btn">
                                          Je choisis
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div class="btn-choice btn-choice-icon sm-no-change">
                                <input v-model="packClasse" type="radio" value="classe_5" id="Stepper5_mobile" name="Step1_mobile" class="field-input">
                                <label for="Stepper5_mobile" class="flex-row flex-md-column field-label" style="box-shadow: 0 0.5rem 1rem rgba(0,0,0,0.1)">
                                  <img src="../assets/img/img-sante/classe5.jpg" alt="classe cinq" class="mr-4 mr-md-0 mt-3" style="opacity:1!important;background-color: #ffa409;box-shadow: 0 0.5rem 1rem rgba(0,0,0,0.1);border-radius: 50%;width:50px;height:50px">
                                  <h3 class="text-center field-title"><span class="font-weight-light">Profil :</span> <span class="ml-2" style="color:#ffa409">Contruction</span></h3>
                                </label>
                              </div>
                              <div class="wizard-tab-content" v-show="packClasse === 'classe_5'" style="margin-top: -5rem;">
                                <div role="tabpanel" id="text_pack_classe_5" aria-hidden="true" aria-labelledby="step-text_pack_classe_5" class="wizard-tab-container">
                                  <div>
                                    <div class="fields mt-5">
                                      <p class="field-sub-title mt-3">
                                        <br>
                                        <span class="font-weight-bold" style="color:#ffa409" @click="detailsPopup = true">Voir les détails</span>
                                      </p>
                                      <div class="wizard-footer-right mb-5">
                                        <button @click="getFiveClasse()" type="button" class="wizard-btn">
                                          Je choisis
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="page" v-show="step === 2">
                    <div class="wizard-tab-content" style="margin-top: -30px">
                      <div role="tabpanel" id="Step1forMobile" aria-labelledby="step-Step1forMobile" class="wizard-tab-container">
                        <div class="fields">
                          <div class="field-title font-weight-bold">Choix&nbsp;:</div>
                          <div class="field-group justify-content-center row flex-column flex-sm-row">
                            <div class="btn-choice btn-choice-icon sm-no-change">
                              <input v-model="garanties" value="DECES" type="checkbox" id="Deces_mobile" name="Step1" @change="garantiesValidator" class="field-input">
                              <label for="Deces_mobile" class="flex-row flex-md-column field-label">
                                <img src="../assets/img/icones/deces.png" alt="deces" class="mr-4 mr-md-0">
                                <p class="text-center">
                                  <span class="tool" data-tip="Versement d’un capital en cas de Décè." tabindex="1">Décès</span>
                                </p>
                              </label>
                            </div>

                            <div class="wizard-tab-content" v-if="capitalValideForDeces">
                              <div role="tabpanel" id="text_capital_deces" aria-hidden="true" aria-labelledby="step-text_capital_deces" class="wizard-tab-container">
                                <div>
                                  <div class="fields">
                                    <div class="field-title mb-0">
                                      <div class="row">
                                        <div class="col-sm-6">
                                          <div class="field-group field-default flex-sm-row mb-3">
                                            <label for="Stepper2_deces_mobile" class="field-label">Capital souhaité pour décès (En million) FCFA</label>
                                            <select id="Stepper2_deces_mobile" v-model="capitalDeces" name="Step1" class="field-select" @change="calculPrimeForDeces">
                                              <option v-for="item in CapitalItems" :key="item" :value="item.value">{{item.capital}}</option>
                                            </select>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div class="btn-choice btn-choice-icon sm-no-change">
                              <input v-model="garanties" type="checkbox" value="INVALIDITE PERMANENTE" id="invalidite_mobile" name="Step1" @change="garantiesValidator" class="field-input">
                              <label for="invalidite_mobile" class="flex-row flex-md-column field-label">
                                <img src="../assets/img/icones/permanent.png" alt="permanent" class="mr-4 mr-md-0">
                                <p class="text-center">
                                  <span class="tool" data-tip="Versement d’un capital en cas d’invalidité permanente." tabindex="1">Invalidité Permanente</span>
                                </p>
                              </label>
                            </div>

                            <div class="wizard-tab-content" v-if="capitalValideForInvalidite">
                              <div role="tabpanel" id="text_capital_incapacite" aria-hidden="true" aria-labelledby="step-text_capital_incapacite" class="wizard-tab-container">
                                <div>
                                  <div class="fields">
                                    <div class="field-title mb-0">
                                      <div class="row">
                                        <div class="col-sm-6">
                                          <div class="field-group field-default flex-sm-row mb-3">
                                            <label for="Stepper2_invalidite_mobile" class="field-label">Capital souhaité pour invalidité (En million) FCFA</label>
                                            <select id="Stepper2_invalidite_mobile" v-model="capitalInvalidite" name="Step1" class="field-select" @change="calculPrimeForInvalide">
                                              <option v-for="item in CapitalItems" :key="item" :value="item.value">{{item.capital}}</option>
                                            </select>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div class="btn-choice btn-choice-icon sm-no-change">
                              <input v-model="garanties" type="checkbox" value="INCAPACITE TEMPORAIRE" id="Incapacite_mobile" name="Step1" @change="garantiesValidator" class="field-input">
                              <label for="Incapacite_mobile" class="flex-row flex-md-column field-label">
                                <img src="../assets/img/icones/temporaire.png" alt="temporaire" class="mr-4 mr-md-0">
                                <p class="text-center">
                                  <span class="tool" data-tip="Versement d’une bourse journalière à hauteur du montant choisi partir du 16eme jours d’incapacité." tabindex="1">Incapacité Temporaire</span>
                                </p>
                              </label>
                            </div>

                            <div class="wizard-tab-content" v-if="bourseValideIncapacite">
                              <div role="tabpanel" id="text_capital_incapacite_mobile" aria-hidden="true" aria-labelledby="step-text_capital_incapacite_mobile" class="wizard-tab-container">
                                <div>
                                  <div class="fields">
                                    <div class="field-title mb-0">
                                      <div class="row">
                                        <div class="col-sm-6">
                                          <div class="field-group field-default flex-sm-row mb-3">
                                            <label for="Stepper2_incapacite_mobile" class="field-label">Bourse incapacité temporaire FCFA</label>
                                            <select id="Stepper2_incapacite_mobile" v-model="bourseIncapacite" name="Step1" class="field-select" @change="calculPrimeIncaTemporaire">
                                              <option v-for="item in incapaciteItems" :key="item" :value="item">{{item}}</option>
                                            </select>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div class="btn-choice btn-choice-icon sm-no-change">
                              <input v-model="garanties" type="checkbox" value="FRAIS MEDICAUX" id="frais_mobile" name="Step1" @change="garantiesValidator" class="field-input">
                              <label for="frais_mobile" class="flex-row flex-md-column field-label">
                                <img src="../assets/img/icones/frais_medicaux.png" alt="frais médicaux" class="mr-4 mr-md-0">
                                <p class="text-center">
                                  <span class="tool" data-tip="Remboursement des frais à hauteur du montant choisi." tabindex="1">Frais Médicaux</span>
                                </p>
                              </label>
                            </div>
                            <div class="wizard-tab-content" v-if="bourseValideFrais">
                              <div role="tabpanel" id="text_capital_frais" aria-hidden="true" aria-labelledby="step-text_capital_frais" class="wizard-tab-container">
                                <div>
                                  <div class="fields">
                                    <div class="field-title mb-0">
                                      <div class="row">
                                        <div class="col-sm-6">
                                          <div class="field-group field-default flex-sm-row">
                                            <label for="Stepper2_frais_mobile" class="field-label">Remboursement frais médicaux FCFA</label>
                                            <select id="Stepper2_frais_mobile" v-model="bourse" name="Step1" class="field-select" @change="calculPrimeFraisMedicaux">
                                              <option v-for="item in RemboursementItems" :key="item" :value="item.bourse">{{item.bourse}}</option>
                                            </select>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="fields">
                            <div class="field-group row flex-column flex-sm-row">
                              <div class="justify-content-center row ml-3 mr-3">
                                <ul class="to-left policeLato mt-5">
                                  <li class="subheading">Profil :
                                    <span class="to-right font-weight-bold" style="color:#ffa409">{{nomClasse}}</span>
                                  </li>
                                  <li v-if="Prime_deces !== null" class="subheading">Prime Décès :
                                    <span class="to-right font-weight-bold" style="color:#ffa409">{{Prime_deces.toLocaleString()}} FCFA</span>
                                  </li>
                                  <li v-if="prime_invalidite !== null" class="subheading">Prime Invalidité :
                                    <span class="to-right font-weight-bold" style="color:#ffa409">{{prime_invalidite.toLocaleString()}} FCFA</span>
                                  </li>
                                  <li v-if="bourseIncapaciteTemporaire !== null" class="subheading">Prime Incapacite :
                                    <span class="to-right font-weight-bold" style="color:#ffa409">{{bourseIncapaciteTemporaire.toLocaleString()}} FCFA</span>
                                  </li>
                                  <li v-if="bourseFraisMedicaux !== null" class="subheading">Prime Frais médicaux :
                                    <span class="to-right font-weight-bold" style="color:#ffa409">{{bourseFraisMedicaux.toLocaleString()}} FCFA</span>
                                  </li>
                                  <li v-if="PrimeNette !== null" class="subheading">Prime Nette :
                                    <span class="to-right font-weight-bold" style="color:#5B94BC">{{PrimeNette.toLocaleString()}} FCFA</span>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="wizard-card-footer clearfix">
                      <div class="wizard-footer-left">
                        <button @click="returToFirstStep()" type="button" class="wizard-btn">
                          <span class="fas fa-arrow-left"></span>
                          Retour
                        </button>
                      </div>
                      <div class="wizard-footer-right">
                        <button @click="stepper2Validator" type="button" class="wizard-btn">
                          Suivant
                        </button>
                      </div>
                      <!---->
                    </div>
                  </div>

                  <div class="page" v-show="step === 3">
                    <div class="wizard-tab-content" style="margin-top: -30px">
                      <div role="tabpanel" id="Step1forContractMobile" aria-labelledby="step-Step1forContractMobile" class="wizard-tab-container">
                        <div class="fields">
                          <div class="field-title font-weight-bold">Souscripteur&nbsp;:</div>
                          <div class="mt-3 justify-content-center row">
                            <div class="justify-content-center row">
                              <p clas="field-title">Le souscripteur est-il le compte connecté ?</p>
                            </div>

                            <div class="justify-content-center row">
                              <p>
                                <label class="toggleSwitch nolabel mt-2 mr-5">
                                  <input :disabled="disabled_checkbox" v-model="checkbox" type="checkbox" @change="getUserDataFromStore"/>
                                  <span>
                                      <span>NON</span>
                                      <span>OUI</span>
                                  </span>
                                  <a></a>
                                </label>
                              </p>
                            </div>
                          </div>


                          <div class="row">
                            <div class="col-sm-4">
                              <div class="field-group field-default mb-4 mb-sm-0">
                                <label for="Stepper28_1_mobile" class="field-label">Prénom</label>
                                <input placeholder="Votre prénom" id="Stepper28_1_mobile" v-model="ContractantFields.Prenom" name="Step8" class="field-input">
                              </div>
                            </div>
                            <div class="col-sm-4">
                              <div class="field-group field-default mb-4 mb-sm-0">
                                <label for="Stepper29_1_mobile" class="field-label">Nom</label>
                                <input placeholder="Votre nom" id="Stepper29_1_mobile" v-model="ContractantFields.Nom" name="Step8" class="field-input">
                              </div>
                            </div>
                            <div class="col-sm-4">
                              <div class="field-group field-default" style="margin-top:-2px">
                                <label for="Stepper30_1_mobile" class="field-label">
                                  Date de naissance
                                  <!---->
                                </label>
                                <div class="input-group value-loan">
                                  <date-picker class="field-input ml-2 mb-1 mt-1" :disabled-date="disabledAfterToday" placeholder="Cliquer ici" id="Stepper30_1_mobile" v-model="ContractantFields.dateNaissance" valueType="format" @change="yearsDiffContractant()" format="YYYY-MM-DD" lang="fr-fr"></date-picker>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="fields">
                          <div class="row">
                            <div class="col-sm-6">
                              <div class="field-group field-default mb-4 mb-sm-0">
                                <label for="Stepper31_1_mobile" class="field-label">CNI</label>
                                <input @keypress="onlyNumber" placeholder="CNI" id="Stepper31_1_mobile" v-model="ContractantFields.Cni" name="Step8" class="field-input">
                              </div>
                            </div>
                            <div class="col-sm-6">
                              <div class="field-group field-default mb-4 mb-sm-0">
                                <label for="Stepper32_1_mobile" class="field-label">Profession</label>
                                <input placeholder="Votre profession" id="Stepper32_1_mobile" v-model="ContractantFields.Profession" name="Step8" class="field-input">
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="wizard-card-footer clearfix">
                      <div class="wizard-footer-left">
                        <button @click="returToSecondStep" type="button" class="wizard-btn">
                          <span class="fas fa-arrow-left"></span>
                          Retour
                        </button>
                      </div>
                      <div class="wizard-footer-right">
                        <button @click="ContractControl" type="button" class="wizard-btn">
                          Suivant
                        </button>
                      </div>
                      <!---->
                    </div>
                  </div>

                  <div class="page review_page" v-show="step === 4">
                    <div data-v-221edead="" class="w-100 Results" pricing="true" style="--custom-color-primary:#35CE7E; --custom-color-primary-light:#5CC7000d;">
                      <div role="tabpanel" id="devis_iAc" aria-labelledby="step-devis_iAc" class="wizard-tab-container">
                        <div data-v-0d43d413="">
                          <div data-v-0d43d413="" class="fields">
                            <div data-v-0d43d413="" class="font-weight-bold field-title mb-0 row justify-content-center">
                              Détails de l'assurance
                            </div>
                          </div>
                        </div>
                      </div>

                      <div data-v-221edead="">
                        <div data-v-221edead="" class="results-deals">
                          <div data-v-221edead="" id="results-table">
                            <div data-v-221edead="" style="top: 0px; width: 100%;">
                              <div data-v-221edead="" class="card-default result text-center naoassur elevation-10">
                                <div data-v-221edead="" class="card-default-body">
                                  <h1 class="field-title row justify-content-center">Souscripteur</h1>
                                  <div data-v-221edead="" class="logo-company logo-company-economy">
                                    <ul class="to-left policeLato">
                                      <li class="field-sub-title">Prénom :
                                        <span class="font-weight-bold field-sub-title to-right">{{ContractantFields.Prenom}}</span>
                                      </li>

                                      <li class="field-sub-title">Nom :
                                        <span class="font-weight-bold field-sub-title to-right">{{ContractantFields.Nom}}</span>
                                      </li>

                                      <li class="field-sub-title">Date de naissance :
                                        <span class="font-weight-bold field-sub-title to-right">{{DateFormater(ContractantFields.dateNaissance)}}</span>
                                      </li>

                                      <li class="field-sub-title">Cni :
                                        <span class="font-weight-bold field-sub-title to-right">{{ContractantFields.Cni}}</span>
                                      </li>

                                      <li class="field-sub-title">Profession :
                                        <span class="font-weight-bold field-sub-title to-right">{{ContractantFields.Profession}}</span>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div data-v-221edead="">
                        <div data-v-221edead="" class="results-deals">
                          <div data-v-221edead="" id="results-table">
                            <div data-v-221edead="" style="top: 0px; width: 100%;">
                              <div data-v-221edead="" class="card-default result text-center naoassur elevation-10">
                                <div data-v-221edead="" class="card-default-body">
                                  <h1 class="field-title row justify-content-center">Garanties</h1>
                                  <div data-v-221edead="" class="logo-company logo-company-economy">
                                    <ul class="to-left policeLato">
                                      <p style="margin-bottom: -3px" class="font-weight-bold">Profil choisi</p>
                                      <li class="field-sub-title" v-for="garantie in this.garanties" :key="garantie">Nom Garantie :
                                        <span class="font-weight-bold field-sub-title to-right">{{garantie}}</span>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div data-v-221edead="">
                        <div data-v-221edead="" class="results-deals">
                          <div data-v-221edead="" id="results-table">
                            <div data-v-221edead="" style="top: 0px; width: 100%;">
                              <div data-v-221edead="" class="card-default result text-center naoassur elevation-10">
                                <div data-v-221edead="" class="card-default-body">
                                  <h1 class="field-title row justify-content-center">Détails</h1>
                                  <div data-v-221edead="" class="logo-company logo-company-economy">
                                    <ul class="to-left policeLato">
                                      <p style="margin-bottom: -3px" class="font-weight-bold">Détails des capitaux</p>
                                      <li class="field-sub-title" v-if="capitalDeces !== null">Capital Décès :
                                        <span class="font-weight-bold field-sub-title to-right">{{capitalDeces.toLocaleString()}} FCFA</span>
                                      </li>
                                      <li class="field-sub-title" v-if="capitalInvalidite !== null">Capital Invalidité :
                                        <span class="font-weight-bold field-sub-title to-right">{{capitalInvalidite.toLocaleString()}} FCFA</span>
                                      </li>
                                      <li class="field-sub-title" v-if="bourse !== null">Frais médicaux:
                                        <span class="font-weight-bold field-sub-title to-right">{{bourse.toLocaleString()}} FCFA</span>
                                      </li>
                                      <li class="field-sub-title" v-if="bourseIncapacite !== null">Incapacité temporaire :
                                        <span class="font-weight-bold field-sub-title to-right">{{bourseIncapacite.toLocaleString()}} FCFA</span>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div role="tabpanel" id="devis_auto" aria-labelledby="step-devis_auto" class="mt-3 wizard-tab-container">
                        <div data-v-0d43d413="">
                          <div data-v-0d43d413="" class="fields">
                            <div data-v-0d43d413="" class="font-weight-bold field-title mb-0 row justify-content-center">
                              Période de couverture
                            </div>

                            <div class="row">
                              <div class="col-sm-6">
                                <div class="field-group field-default mb-4 mb-sm-0">
                                  <label for="Stepper39_mobile" class="field-label">Date d'effet
                                    <button type="button" tabindex="-1" title="" class="field-help" data-original-title="Taux d'intérêt"></button></label>
                                  <div class="input-group rate-loan">
                                    <date-picker id="Stepper39_mobile" :disabled-date="disabledBeforeToday" class="field-input ml-2 mb-1 mt-1" placeholder="Cliquer ici" @change="dateDiff()" :min="new Date().toISOString().substr(0, 10)" v-model="dateEffet" valueType="format" format="YYYY-MM-DD" lang="fr-fr"></date-picker>
                                  </div>
                                </div>
                              </div>
                              <div class="col-sm-6">
                                <div class="field-group field-default mb-4 mb-sm-0">
                                  <label for="Stepper40_mobile" class="field-label">Date d'échéance
                                    <button type="button" tabindex="-1" title="" class="field-help" data-original-title="Taux d'intérêt"></button></label>
                                  <div class="input-group rate-loan">
                                    <input disabled placeholder="Date d'échéance" v-model="dateEcheance" id="Stepper40_mobile" name="Step11" class="field-input">
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div class="fields">
                              <div class="field-group row flex-column flex-sm-row">
                                <div class="justify-content-center row ml-3 mr-3">
                                  <ul class="to-left policeLato">
                                    <li class="subheading">Profil :
                                      <span class="to-right font-weight-bold" style="color:#ffa409">{{nomClasse}}</span>
                                    </li>
                                    <li v-if="Prime_deces !== null" class="subheading">Prime Décès :
                                      <span class="to-right font-weight-bold" style="color:#ffa409">{{Prime_deces.toLocaleString()}} FCFA</span>
                                    </li>
                                    <li v-if="prime_invalidite !== null" class="subheading">Prime Invalidité :
                                      <span class="to-right font-weight-bold" style="color:#ffa409">{{prime_invalidite.toLocaleString()}} FCFA</span>
                                    </li>
                                    <li v-if="bourseIncapaciteTemporaire !== null" class="subheading">Prime Incapacité :
                                      <span class="to-right font-weight-bold" style="color:#ffa409">{{bourseIncapaciteTemporaire.toLocaleString()}} FCFA</span>
                                    </li>
                                    <li v-if="bourseFraisMedicaux !== null" class="subheading">Prime Frais médicaux :
                                      <span class="to-right font-weight-bold" style="color:#ffa409">{{bourseFraisMedicaux.toLocaleString()}} FCFA</span>
                                    </li>
                                    <li v-if="SurprimeNette !== null" class="subheading">Surprime Totale :
                                      <span class="to-right font-weight-bold" style="color:#ffa409">{{SurprimeNette.toLocaleString()}} FCFA</span>
                                    </li>
                                    <li v-if="PrimeNette !== null" class="subheading">Prime Nette :
                                      <span class="to-right font-weight-bold" style="color:#ffa409">{{PrimeNette.toLocaleString()}} FCFA</span>
                                    </li>
                                    <li v-if="frais !== null" class="subheading">Frais :
                                      <span class="to-right font-weight-bold" style="color:#ffa409">{{frais.toLocaleString()}} FCFA</span>
                                    </li>
                                    <li v-if="taxe !== null" class="subheading">Taxe :
                                      <span class="to-right font-weight-bold" style="color:#ffa409">{{taxe.toLocaleString()}} FCFA</span>
                                    </li>
                                    <li v-if="PrimeTTC !== null" class="subheading">Prime TTC :
                                      <span class="to-right font-weight-bold" style="color:#5B94BC">{{PrimeTTC.toLocaleString()}} FCFA</span>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </div>

                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="wizard-card-footer clearfix">
                      <div class="wizard-footer-left">
                        <button @click="returToThirstStep()" type="button" class="wizard-btn">
                          <span class="fas fa-arrow-left"></span>
                          Retour
                        </button>
                      </div>
                      <div class="wizard-footer-right">
                        <button :disabled="disabledButtonValidate" @click="CreateDevisIndividu()" type="button" class="wizard-btn">
                          Valider
                        </button>
                      </div>
                      <!---->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- ========= DIALOG SURPRIME ============ -->
    <!-- ========= DIALOG SURPRIME ============ -->
    <v-dialog v-model="SurprimeDialog" persistent width="600" scrollable>
      <v-card elevation="24" class="border-radius">
        <v-card-text style="background:#FAFAFA">
          <div class="wizard-tab-content">
            <div role="tabpanel" id="Popup_autre" aria-hidden="true" aria-labelledby="step-Popup_autre" class="wizard-tab-container">
              <div>
                <div class="loan-group loan-group-0">
                  <div class="fields">
                    <div class="field-title font-weight-bold">Pratiquez-vous une de ces activités ?</div>
                    <div class="field-group justify-content-center row field-bank mt-5">
                      <div class="btn-choice sm-no-change col-sm-6">
                        <input type="checkbox" v-model="Surprimes" value="Sport" id="Sport" name="Step9" @change="surprimeCalcul" class="field-input">
                        <label for="Sport" class="field-label">
                          <h3 class="mt-3 text-center">
                            <span tabindex="1">Pratique des sports</span>
                          </h3>
                        </label>
                      </div>
                      <div class="btn-choice sm-no-change col-sm-6">
                        <input type="checkbox" v-model="Surprimes" value="cycle_moteur" id="cycle_moteur" name="Step9" @change="surprimeCalcul" class="field-input">
                        <label for="cycle_moteur" class="field-label">
                          <h3 class="mt-3 text-center">
                            <span tabindex="1">Usage de cycle à moteur</span>
                          </h3>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="wizard-tab-content" v-if="Surprimes =='Sport'">
            <div role="tabpanel" id="text_surprime_sport" aria-hidden="true" aria-labelledby="step-text_surprime_sport" class="wizard-tab-container">
              <div>
                <div class="fields">
                  <div class="field-title mb-0">
                    Surprime Sport
                  </div>
                  <p class="field-sub-title mb-5">
                    <span>Exclusions : escalade, alpinisme, spéléologie, skeleton, polo à cheval,
                          sport de combat sans arme (boxe, lutte, judo. karaté, etc.),
                          chasse et plongée sous-marine, yachting à moteur (embarcation de plus de 16 noeuds)</span> <br>
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div class="wizard-tab-content" v-if="Surprimes =='cycle_moteur'">
            <div role="tabpanel" id="text_surprime_cycle" aria-hidden="true" aria-labelledby="step-text_surprime_cycle" class="wizard-tab-container">
              <div>
                <div class="fields">
                  <div class="field-title mb-0">
                    Surprime Usage de cycle
                  </div>
                  <p class="field-sub-title mb-5">
                    <span>Usage de cycles à moteur d'une cylindrée supérieur à <span class="font-weight-bold">50 cm3</span> motocyclettes et tricars</span> <br>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="wizard-card-footer clearfix">
            <div class="wizard-footer-left">
              <button @click="nextToContractStep" type="button" class="wizard-btn">
                <span class="fas fa-arrow-left"></span>
                Non
              </button>
            </div>
            <div class="wizard-footer-right">
              <button @click="SurprimeValidator" type="button" class="wizard-btn">
                Oui
              </button>
            </div>
            <!---->
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- ========= DIALOG DETAILS PACKS ============ -->
    <!-- ========= DIALOG DETAILS PACKS ============ -->
    <v-dialog v-model="detailsPopup" width="600" scrollable>
      <v-card elevation="24" class="border-radius">
        <v-card-text style="background:#FAFAFA">
          <div class="wizard-tab-content">
            <div role="tabpanel" id="Popup_autre" aria-hidden="true" aria-labelledby="step-Popup_autre" class="wizard-tab-container">
              <div>
                <div class="loan-group loan-group-0">
                  <div class="fields">
                    <div class="row">
                      <ul v-show="packClasse === 'classe_1'">
                        <li class="font-weight-bold" style="list-style: none;font-size: 30px">Détails</li>
                        <li class="font-weight-bold" style="list-style: none;color:#ffa409;font-size: 20px">Description</li>
                        <li>{{ metierClasses[0].description  }}</li>
                        <br>
                        <li class="font-weight-bold" style="list-style: none;color:#ffa409;font-size: 20px">Profession</li>
                        <li>{{ metierClasses[0].profession[0] }}</li>
                        <li>{{ metierClasses[0].profession[1] }}</li>
                        <li>{{ metierClasses[0].profession[2] }}</li>
                        <li>{{ metierClasses[0].profession[3] }}</li>
                      </ul>

                      <ul v-show="packClasse === 'classe_2'">
                        <li class="font-weight-bold" style="list-style: none;font-size: 30px">Détails</li>
                        <li class="font-weight-bold" style="list-style: none;color:#ffa409;font-size: 20px">Description</li>
                        <li>{{ metierClasses[1].description  }}</li>
                        <br>
                        <li class="font-weight-bold" style="list-style: none;color:#ffa409;font-size: 20px">Profession</li>
                        <li>{{ metierClasses[1].profession[0] }}</li>
                        <li>{{ metierClasses[1].profession[1] }}</li>
                        <li>{{ metierClasses[1].profession[2] }}</li>
                      </ul>

                      <ul v-show="packClasse === 'classe_3'">
                        <li class="font-weight-bold" style="list-style: none;font-size: 30px">Détails</li>
                        <li class="font-weight-bold" style="list-style: none;color:#ffa409;font-size: 20px">Description</li>
                        <li>{{ metierClasses[2].description  }}</li>
                        <br>
                        <li class="font-weight-bold" style="list-style: none;color:#ffa409;font-size: 20px">Profession</li>
                        <li>{{ metierClasses[2].profession[0] }}</li>
                        <li>{{ metierClasses[2].profession[1] }}</li>
                        <li>{{ metierClasses[2].profession[2] }}</li>
                        <li>{{ metierClasses[2].profession[3] }}</li>
                      </ul>

                      <ul v-show="packClasse === 'classe_4'">
                        <li class="font-weight-bold" style="list-style: none;font-size: 30px">Détails</li>
                        <li class="font-weight-bold" style="list-style: none;color:#ffa409;font-size: 20px">Description</li>
                        <li>{{ metierClasses[3].description  }}</li>
                        <br>
                        <li class="font-weight-bold" style="list-style: none;color:#ffa409;font-size: 20px">Profession</li>
                        <li>{{ metierClasses[3].profession[0] }}</li>
                        <li>{{ metierClasses[3].profession[1] }}</li>
                        <li>{{ metierClasses[3].profession[2] }}</li>
                        <li>{{ metierClasses[3].profession[3] }}</li>
                      </ul>

                      <ul v-show="packClasse === 'classe_5'">
                        <li class="font-weight-bold" style="list-style: none;font-size: 30px">Détails</li>
                        <li class="font-weight-bold" style="list-style: none;color:#ffa409;font-size: 20px">Description</li>
                        <li>{{ metierClasses[4].description  }}</li>
                        <br>
                        <li class="font-weight-bold" style="list-style: none;color:#ffa409;font-size: 20px">Profession</li>
                        <li>{{ metierClasses[4].profession[0] }}</li>
                        <li>{{ metierClasses[4].profession[1] }}</li>
                        <li>{{ metierClasses[4].profession[2] }}</li>
                        <li>{{ metierClasses[4].profession[3] }}</li>
                        <li>{{ metierClasses[4].profession[4] }}</li>
                        <li>{{ metierClasses[4].profession[5] }}</li>
                        <li>{{ metierClasses[4].profession[6] }}</li>
                        <li>{{ metierClasses[4].profession[7] }}</li>
                        <li>{{ metierClasses[4].profession[8] }}</li>
                        <li>{{ metierClasses[4].profession[9] }}</li>
                        <li>{{ metierClasses[4].profession[10] }}</li>
                        <li>{{ metierClasses[4].profession[11] }}</li>
                        <li>{{ metierClasses[4].profession[12] }}</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <div v-if="dialogLoading" class="loading-state">
        <div class="loading"></div>
        <span class="ml-3 loading-text">{{ $t('devis.devis_auto.devis_encours') }}</span>
    </div>


    <!-- <v-dialog v-model="dialogLoading" persistent width="700" v-if="isDesktop()">
            <v-card elevation="24" class="border-radius">
                <v-card-text style="background:#FFA409">
                <div class="wizard-tab-content" style="background:#FFA409">
                    <div role="tabpanel" id="infosPerso" aria-hidden="true" aria-labelledby="step-infosPerso" class="wizard-tab-container">
                    <div>
                        <div class="loan-group loan-group-0" style="background:#FFA409">
                        <div class="fields text-center" style="background:#FFA409">
                            <v-progress-circular size="50" color="white" class="mr-2" indeterminate></v-progress-circular> 
                            <span class="field-title font-weight-bold" style="color:#fff">{{ $t('devis.devis_auto.devis_encours') }}</span>
                        </div>
                        </div>
                    </div>
                    </div>
                </div>
                </v-card-text>
            </v-card>
    </v-dialog>

    <v-dialog v-model="dialogLoading" persistent width="700" v-if="isMobile()">
        <v-card elevation="24" class="border-radius">
        <v-card-text style="background:#FFA409">
            <div class="wizard-tab-content" style="background:#FFA409">
            <div role="tabpanel" id="infosPerso" aria-hidden="true" aria-labelledby="step-infosPerso" class="wizard-tab-container">
                <div>
                <div class="loan-group loan-group-0" style="background:#FFA409">
                    <div class="fields text-center" style="background:#FFA409">
                        <span class="field-title font-weight-bold" style="color:#fff">{{ $t('devis.devis_auto.devis_encours') }}</span>
                    </div>
                    <div class="fields text-center" style="background:#FFA409">
                        <v-progress-circular size="50" color="white" class="mr-2" indeterminate></v-progress-circular>
                    </div>
                </div>
                </div>
            </div>
            </div>
        </v-card-text>
        </v-card>
    </v-dialog> -->
    <!-- INCLUSION DU POPUP DE LOGIN AU CAS OU LE USER VOULANT FAIRE UNE VALIDATION N'EST PAS CONNECTE -->
    <login-form :visible="showLoginForm" @close="showLoginForm=false"></login-form>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import Api from '../services/Api'
import store from '../store/store'
import LoginForm from './auth/Login'
import {
  mask
} from 'vue-the-mask'
import FraisMedicaux from '@/common/fraismedicaux.json'
import Capitaux from '@/common/capital.json'
import qm from '../common/q_medical_indiv_accident.json'
export default {
  name: 'Individuel_accident',
  components: {
    LoginForm
  },
  directives: {
    mask,
  },
  data() {
    return {
      dialogLoading : false,
      disabledButtonValidate : false,
      packClasse : null,
      PrimeTTC : null,
      taxe: null,
      frais : 2000,
      test : [],
      nomClasse : '',
      classNumber : null,
      disabled_checkbox : false,
      checkbox: false,
      SurprimeNette : null,
      Surprime : null,
      Surprimes : [],
      Surprime_sport_deces : null,
      Surprime_sport_invalidite : null,
      Surprime_sport_incapacite : null,
      Surprime_Sport_fraisMedicaux : null,

      Surprime_cycle_deces : null,
      Surprime_cycle_invalidite : null,
      Surprime_cycle_incapacite : null,
      Surprime_cycle_fraisMedicaux : null,

      Surprime_cycle : null,
      incapaciteItems: [10000, 20000, 30000],
      PrimeNette : null,
      Prime_deces : null,
      prime_invalidite : null,
      // Contractant fields
      ContractantFields: {
        Nom: null,
        Prenom: null,
        dateNaissance: null,
        Cni: null,
        Profession: null,
        Questionnaire:null
      },
      capitalValideForDeces : true,
      capitalValideForInvalidite : true,
      bourseFraisMedicaux : null,
      bourseIncapaciteTemporaire : null,
      bourseValideFrais : false,
      bourseValideIncapacite :  false,
      bourseValide : false,
      capitalDeces: null,
      capitalInvalidite : null,
      donne_prime : null,
      bourse : null,
      bourseIncapacite : null,
      garanties : ['DECES','INVALIDITE PERMANENTE'],
      fraisMedicaux : null,
      capitalList : null,
      CapitalItems: [],
      RemboursementItems: [],
      classe : null,
      listClasses : [],
      firstClassDescription : false,
      metierClasses: null,

      SurprimeDialog : false,
      detailsPopup :  false,
      dateEffet:null,
      dateEcheance:null,
      money: {
        thousands: ' ',
        precision: false,
        masked: false,
        suffix: ' FCFA'
      },
      payement: null,
      ToastTabSucess: {  // Customized options for success toast
        theme: "toasted-primary",
        position: "top-center",
        duration: 7000,
        fitToScreen: true,
        type: 'info',
        className: 'custom-success-class'
      },
      ToastTabError: {  // Customized options for error toast
        theme: "toasted-primary",
        position: "top-center",
        duration: 7000,
        fitToScreen: true,
        type: 'error'
      },
      step:1,
      showLoginForm: false,
      suivant: false,
      a : null,
      b : null
    }
  },
  methods: {
    checkToken() {
        Api().get('user/check/token')
        .then((resultat) => {
          // verifie si le token exist
          if (!resultat.data.ok) {
            store.state.isUserLoggedIn = false;
            store.dispatch("setUser", {});
              store.dispatch("setToken", {});
              this.showLoginForm = true
            }
          }).catch((err) => {
            // verifie  si le token est expiré
            if(err.response.data.ok === false){
              store.state.isUserLoggedIn = false;
              store.dispatch("setUser", {});
              store.dispatch("setToken", {});
              this.showLoginForm = true
            }
          });
    },
    getUserDataFromStore(){
      if(this.checkbox == true){
        if (!store.state.isUserLoggedIn) {
          this.showLoginForm = true
        } else if(store.state.isUserLoggedIn){
          this.ContractantFields.Nom = this.$store.state.user.nom
          this.ContractantFields.Prenom = this.$store.state.user.prenom
          this.ContractantFields.dateNaissance = this.$store.state.user.datenaissance
          this.ContractantFields.Cni = this.$store.state.user.numero_piece
          this.ContractantFields.Profession = this.$store.state.user.profession
        }
      }else if(this.checkbox == false) {
        this.ClearForm()
      }
    },

    ClearForm: function () {
      this.ContractantFields.Nom = null
      this.ContractantFields.Prenom = null
      this.ContractantFields.dateNaissance = null
      this.ContractantFields.Cni = null
      this.ContractantFields.Profession = null

    },

    yearsDiffContractant() {
      const date1 = dayjs(this.ContractantFields.dateNaissance);
      const date2 = dayjs(new Date().toISOString().substr(0, 10));
      let daydiff = date2.diff(date1, 'days');
      this.age = daydiff;

      if (this.age <0) {
        this.age = null;
        this.$toasted.show('Erreur, date antérieure à la date actuelle! ', this.ToastTabError)
        this.ContractantFields.dateNaissance = null

      } else if (this.age) {
        let year = Math.floor(this.age / 360);
        this.age = year;
        if(this.age < 18 || this.age <= 0){
          this.$toasted.show("Erreur, l'age doit pas etre supperieur à 18 ans! ", this.ToastTabError)
          this.ContractantFields.dateNaissance = null
        }
      }
      else if (this.age<=0) {
        let year = Math.floor(this.age / 360);
        this.age = year;
        if(this.age < 18 || this.age <= 0){
          this.$toasted.show("Erreur, l'age doit pas etre supperieur à 18 ans! ", this.ToastTabError)
          this.ContractantFields.dateNaissance = null
        }
      }
    },

    surprimeCalcul(){
    for (let index = 0; index < this.garanties.length; index++) 
    {
      if(this.Surprimes.indexOf("Sport") !== -1 && this.Surprimes.indexOf("cycle_moteur") !== -1){
        if(this.garanties[index] == 'DECES'){
            this.Surprime_cycle_deces =  0 //this.capitalDeces * 0.75/1000
          console.log(this.Surprime_cycle_deces)
        }
        else if(this.garanties[index] == 'INVALIDITE PERMANENTE') 
        {
          this.Surprime_cycle_invalidite =  0 //this.capitalInvalidite * 0.75/1000
          console.log(this.Surprime_cycle_invalidite)
        }
        else if(this.garanties[index] == 'INCAPACITE TEMPORAIRE')
        {
          this.Surprime_cycle_incapacite =  0 //this.bourseIncapacite * 1
          console.log(this.Surprime_cycle_incapacite)
        }
        else if(this.garanties[index] == 'FRAIS MEDICAUX')
        {
          if(this.bourse == 125000)
          {
            this.Surprime_cycle_fraisMedicaux =  0 //2500
            console.log(this.Surprime_cycle_fraisMedicaux)
          } else if(this.bourse == 250000)
          {
            this.Surprime_cycle_fraisMedicaux =  0 //3000
          }else if(this.bourse == 500000) 
          {
            this.Surprime_cycle_fraisMedicaux =  0 //3750
          }
        }
      }else {
        this.Surprime_sport_deces = null
        this.Surprime_sport_invalidite = null
        this.Surprime_sport_incapacite = null
        this.Surprime_Sport_fraisMedicaux = null

        this.Surprime_cycle_deces = null
        this.Surprime_cycle_invalidite = null
        this.Surprime_cycle_incapacite = null
        this.Surprime_cycle_fraisMedicaux = null

        if(this.garanties[index] == 'DECES')
        {
          if(this.Surprimes == 'Sport')
          {
            this.Surprime_sport_deces = 0 //this.capitalDeces * 0.3/1000
            console.log(this.Surprime_sport_deces)
          }else if(this.Surprimes == 'cycle_moteur')
          {
            this.Surprime_cycle_deces =  0 //this.capitalDeces * 0.75/1000
            console.log(this.Surprime_cycle_deces)
          } else {
            this.Surprime_cycle_deces = 0
            this.Surprime_cycle_deces = 0
          }

        }
        else if(this.garanties[index] == 'INVALIDITE PERMANENTE')
        {
          if(this.Surprimes == 'Sport')
          {
            this.Surprime_sport_invalidite =  0 //this.capitalInvalidite * 0.6/1000
          }else if(this.Surprimes == 'cycle_moteur')
          {
            this.Surprime_cycle_invalidite =  0 //this.capitalInvalidite * 0.75/1000
          } else {
            this.Surprime_sport_invalidite = 0
            this.Surprime_cycle_invalidite = 0
          }
        }
        else if(this.garanties[index] == 'INCAPACITE TEMPORAIRE')
        {
          if(this.Surprimes == 'Sport')
          {
            this.Surprime_sport_incapacite =  0 //this.bourseIncapacite * 1
          }else if(this.Surprimes == 'cycle_moteur')
          {
            this.Surprime_cycle_incapacite =  0 //this.bourseIncapacite * 1
          } else {
            this.Surprime_sport_incapacite = 0
            this.Surprime_cycle_incapacite = 0
          }
        }
        else if(this.garanties[index] == 'FRAIS MEDICAUX')
        {
          if(this.Surprimes == 'Sport')
          {
            if(this.bourse == 125000)
            {
              this.Surprime_Sport_fraisMedicaux =  0 //1250
            } else if(this.bourse == 250000)
            {
              this.Surprime_Sport_fraisMedicaux =  0 //1750
            }else if(this.bourse == 500000) 
            {
              this.Surprime_Sport_fraisMedicaux =  0 //2250
            }
          }
          else if(this.Surprimes == 'cycle_moteur')
          {
            if(this.bourse == 125000)
            {
              this.Surprime_cycle_fraisMedicaux =  0 //2500
            } else if(this.bourse == 250000)
            {
              this.Surprime_cycle_fraisMedicaux =  0 //3000
            }else if(this.bourse == 500000) 
            {
              this.Surprime_cycle_fraisMedicaux =  0 //3750
            }
          } else {
            this.Surprime_Sport_fraisMedicaux = 0
            this.Surprime_cycle_fraisMedicaux = 0
          }
        }
      }

      }
      this.calculPrimeTotal()
    },

    SurprimeValidator(){
      if(this.Surprimes.indexOf("Sport") !== -1 || this.Surprimes.indexOf("cycle_moteur") !== -1 ){
        let primeDeces = this.Surprime_sport_deces + this.Surprime_cycle_deces
        let primeInvalidite = this.Surprime_sport_invalidite + this.Surprime_cycle_invalidite
        let primeIncapacite = this.Surprime_sport_incapacite + this.Surprime_cycle_incapacite
        let primeFraisMedicaux = this.Surprime_Sport_fraisMedicaux + this.Surprime_cycle_fraisMedicaux
        this.SurprimeNette = primeDeces + primeInvalidite + primeIncapacite + primeFraisMedicaux
        this.SurprimeDialog = false
        this.step = 3
        document.getElementById("secondStep").classList.add('checked');
        document.getElementById("testup").classList.add('widthSecond');
        this.calculPrimeTotal()
      }else {
        this.$toasted.show('Veuillez faire un choix! ', this.ToastTabError)
      }
    },

    nextToContractStep(){
      this.SurprimeDialog = false
      this.step = 3
      this.Surprimes = null
      document.getElementById("secondStep").classList.add('checked');
      document.getElementById("testup").classList.add('widthSecond');
    },

    calculPrimeTotal(){
      this.PrimeNette = this.Prime_deces + this.prime_invalidite + this.bourseFraisMedicaux + this.bourseIncapaciteTemporaire + this.SurprimeNette
      this.calculTaxe()
      console.log(this.PrimeNette)
    },

    ContractControl() {
      if (this.ContractantFields.Nom && this.ContractantFields.Prenom) {
        if(this.ContractantFields.dateNaissance){
          if(this.ContractantFields.Cni && this.ContractantFields.Profession){
            this.ContractantFields.Questionnaire = qm
            document.getElementById("thirstStep").classList.add('checked');
            document.getElementById("testup").classList.add('widthThirt');
            this.step = 4
            this.calculPrimeTTC()
          }else {
            this.$toasted.show('Cni et Profession obligatoires! ', this.ToastTabError)
          }
        }else {
          this.$toasted.show('Date de naissance obligatoire! ', this.ToastTabError)
        }
      } else {
        this.$toasted.show('Nom et Prénom obligatoires! ', this.ToastTabError)
      }
    },

    calculPrimeForDeces(){
      let C = this.classe.classe
      for (let index = 0; index < this.garanties.length; index++) {
        if(C == 1){
          if(this.garanties[index] == 'DECES'){
            this.Prime_deces = this.capitalDeces * 1.3 /1000
          }
        }
        else if(C == 2){
          if(this.garanties[index] == 'DECES'){
            this.Prime_deces = this.capitalDeces * 1.7 /1000
          }
        }
        else if(C == 3){
          if(this.garanties[index] == 'DECES'){
            this.Prime_deces = this.capitalDeces * 2.2 /1000
          }
        }
        else if(C == 4){
          if(this.garanties[index] == 'DECES'){
            this.Prime_deces = this.capitalDeces * 2.7 /1000
          }
        }
        else if(C == 5){
          if(this.garanties[index] == 'DECES'){
            this.Prime_deces = this.capitalDeces * 5.2 /1000
          }
        }
      }
      this.calculPrimeTotal()
    },

    calculPrimeForInvalide(){
      let C = this.classe.classe
      for (let index = 0; index < this.garanties.length; index++) {
        if(C == 1){
          if(this.garanties[index] == 'INVALIDITE PERMANENTE'){
            this.prime_invalidite = this.capitalInvalidite * 1.4 /1000
          }
        }
        else if(C == 2){
          if(this.garanties[index] == 'INVALIDITE PERMANENTE'){
            this.prime_invalidite = this.capitalInvalidite * 1.9 /1000
          }
        }
        else if(C == 3){
          if(this.garanties[index] == 'INVALIDITE PERMANENTE'){
            this.prime_invalidite = this.capitalInvalidite * 2.5 /1000
          }
        }
        else if(C == 4){
          if(this.garanties[index] == 'INVALIDITE PERMANENTE'){
            this.prime_invalidite = this.capitalInvalidite * 3.2 /1000
          }
        }
        else if(C == 5){
          if(this.garanties[index] == 'INVALIDITE PERMANENTE'){
            this.prime_invalidite = this.capitalInvalidite * 5.2 /1000
          }
        }
      }
      this.calculPrimeTotal()
    },

    calculPrimeFraisMedicaux(){
      let C = this.classe.classe

      if(this.bourse == 125000){
        if(C == 1){
          this.bourseFraisMedicaux = this.fraisMedicaux.capital[0].donne_prime[0].prime
        }else if(C == 2){
          this.bourseFraisMedicaux = this.fraisMedicaux.capital[0].donne_prime[1].prime
        }else if(C == 3){
          this.bourseFraisMedicaux = this.fraisMedicaux.capital[0].donne_prime[2].prime
        }else if(C == 4){
          this.bourseFraisMedicaux = this.fraisMedicaux.capital[0].donne_prime[3].prime
        }else if(C == 5){
          this.bourseFraisMedicaux = this.fraisMedicaux.capital[0].donne_prime[4].prime
        }

      }
      else if(this.bourse == 250000){
        if(C == 1){
          this.bourseFraisMedicaux = this.fraisMedicaux.capital[1].donne_prime[0].prime
        }else if(C == 2){
          this.bourseFraisMedicaux = this.fraisMedicaux.capital[1].donne_prime[1].prime
        }else if(C == 3){
          this.bourseFraisMedicaux = this.fraisMedicaux.capital[1].donne_prime[2].prime
        }else if(C == 4){
          this.bourseFraisMedicaux = this.fraisMedicaux.capital[1].donne_prime[3].prime
        }else if(C == 5){
          this.bourseFraisMedicaux = this.fraisMedicaux.capital[1].donne_prime[4].prime
        }
      }
      else if(this.bourse == 500000){
        if(C == 1){
          this.bourseFraisMedicaux = this.fraisMedicaux.capital[2].donne_prime[0].prime
        }else if(C == 2){
          this.bourseFraisMedicaux = this.fraisMedicaux.capital[2].donne_prime[1].prime
        }else if(C == 3){
          this.bourseFraisMedicaux = this.fraisMedicaux.capital[2].donne_prime[2].prime
        }else if(C == 4){
          this.bourseFraisMedicaux = this.fraisMedicaux.capital[2].donne_prime[3].prime
        }else if(C == 5){
          this.bourseFraisMedicaux = this.fraisMedicaux.capital[2].donne_prime[4].prime
        }
      }
      this.calculPrimeTotal()
    },

    calculPrimeIncaTemporaire(){
      let C = this.classe.classe

      if(this.bourseIncapacite){
        if(C == 1){
          this.bourseIncapaciteTemporaire = this.bourseIncapacite * 2.3
        }else if(C == 2){
          this.bourseIncapaciteTemporaire = this.bourseIncapacite * 3
        }else if(C == 3){
          this.bourseIncapaciteTemporaire = this.bourseIncapacite * 4
        }else if(C == 4){
          this.bourseIncapaciteTemporaire = this.bourseIncapacite * 7
        }else if(C == 5){
          this.bourseIncapaciteTemporaire = this.bourseIncapacite * 8
        }
      }
      this.calculPrimeTotal()
    },

    stepper2Validator(){
     if (this.garanties.length >= 1) {
         if(this.garanties.indexOf("DECES") !== -1 || this.garanties.indexOf("INVALIDITE PERMANENTE") !== -1){
           for (let index = 0; index < this.garanties.length; index++) {
             if (this.garanties[index] == 'DECES') {
               if (this.capitalDeces) {
                 if(this.capitalValideForInvalidite == true){
                   if(this.capitalInvalidite){
                     this.SurprimeDialog = true
                   }
                 }else {
                   this.SurprimeDialog = true
                 }
               } else {
                 this.$toasted.show('Capital Décès obligatoire! ', this.ToastTabError)
               }
             }
             else if(this.garanties[index] == 'INVALIDITE PERMANENTE'){
               if(this.capitalInvalidite){
                 if(this.capitalValideForDeces == true){
                   if(this.capitalDeces){
                     this.SurprimeDialog = true
                   }
                 }else {
                   this.SurprimeDialog = true
                 }
               }else {
                 this.$toasted.show('Capital invalidité obligatoire! ', this.ToastTabError)
               }
             }
             else if(this.garanties[index] == 'INCAPACITE TEMPORAIRE'){
               if(this.bourseIncapacite){
                 this.step = 3
               }else {
                 this.$toasted.show('Ramoursement incapacité temporaire obligatoire! ', this.ToastTabError)
               }
             }
             else if(this.garanties[index] == 'FRAIS MEDICAUX'){
               if(this.bourse){
                 if(this.bourseValideIncapacite == true){
                   if(this.bourseIncapacite){
                     this.SurprimeDialog = true
                   }
                 }else {
                   this.SurprimeDialog = true
                 }
                 //this.step = 3
               }else {
                 this.$toasted.show('Ramoursement obligatoire! ', this.ToastTabError)
               }
             }
           }
         }else {
           this.$toasted.show('Garantie Décès ou Invalidite permanente obligatoire !', this.ToastTabError)
         }
      } else {
        this.$toasted.show('Veuillez cocher une garantie au minimum ! ', this.ToastTabError)
      }
    },

    garantiesValidator(){
      let CapitalDeces = 0
      let CapitalInvalidite = 0
      let BourseFraisMedicaux = 0
      let BourseIncapacite = 0
      for (let index = 0; index < this.garanties.length; index++) {
        if (this.garanties[index] == 'DECES') {
          CapitalDeces = 1
        }else if(this.garanties[index] == 'INVALIDITE PERMANENTE'){
          CapitalInvalidite = 1
        }else if(this.garanties[index] == 'FRAIS MEDICAUX'){
          BourseFraisMedicaux = 1
        }else if(this.garanties[index] == 'INCAPACITE TEMPORAIRE'){
          BourseIncapacite = 1
        }
      }

      if (CapitalDeces == 1) {
        this.capitalValideForDeces = true
      } else {
        this.capitalValideForDeces = false
        this.capitalDeces = null
        this.Prime_deces = null
        this.calculPrimeTotal()

      }

      if(CapitalInvalidite == 1) {
        this.capitalValideForInvalidite = true
      }else {
        this.capitalValideForInvalidite = false
        this.capitalInvalidite = null
        this.prime_invalidite = null
        this.calculPrimeTotal()
      }

      if(BourseFraisMedicaux == 1) {
        this.bourseValideFrais = true
      }else {
        this.bourseValideFrais = false
        this.bourse = null
        this.bourseFraisMedicaux = null
        this.calculPrimeTotal()
      }

      if(BourseIncapacite == 1) {
        this.bourseValideIncapacite = true
      }else {
        this.bourseValideIncapacite = false
        this.bourseIncapacite = null
        this.bourseIncapaciteTemporaire = null
        this.calculPrimeTotal()
      }
    },

    getListeBourse(){
      for(let i of this.fraisMedicaux.capital){
        let bourse = i
        this.RemboursementItems.push(bourse)
      }
    },

    getListeCapitaux(){
     for(let i of this.capitalList.capital){
        let capital = i
        this.CapitalItems.push(capital)
      }
    },

    /*================= retour à la premiere étape ==============*/
    returToFirstStep(){
      document.getElementById("firstStep").classList.remove('checked');
      document.getElementById("testup").classList.remove('widthFirst');
      this.step = 1
      this.bourse = null
      this.capitalDeces = null
      this.capitalInvalidite = null
      this.bourseIncapacite = null
      this.bourse = null
      this.garanties.pop()
    },

    returToSecondStep(){
      this.step = 2
      document.getElementById("secondStep").classList.remove('checked');
      document.getElementById("testup").classList.remove('widthSecond');
    },

    /*================= retour à la troisieme étape ==============*/
    returToThirstStep(){
      this.step = 3
      document.getElementById("thirstStep").classList.remove('checked');
      document.getElementById("testup").classList.remove('widthThirt');
    },

    /*================= Recuperation des classes depuis l'api ==============*/
    getListeClass: function () {
      Api().get('classe_metier/index')
          .then(response => {
            this.listClasses = response.data
            this.metierClasses = this.listClasses
          })
    },

    getFirstClasse(){
      this.classe = this.metierClasses[0]
      this.classNumber = this.metierClasses[0].classe
      this.step = 2
      this.nomClasse = 'Bureau'
      document.getElementById("firstStep").classList.add('checked');
      document.getElementById("testup").classList.add('widthFirst');
    },

    getSecondClasse(){
      this.classe = this.metierClasses[1]
      this.classNumber = this.metierClasses[1].classe
      this.step = 2
      this.nomClasse = 'Employé bureau + Manuel'
      document.getElementById("firstStep").classList.add('checked');
      document.getElementById("testup").classList.add('widthFirst');
    },

    getThirstClasse(){
      this.classe = this.metierClasses[2]
      this.classNumber = this.metierClasses[2].classe
      this.step = 2
      this.nomClasse = 'Artisans'
      document.getElementById("firstStep").classList.add('checked');
      document.getElementById("testup").classList.add('widthFirst');
    },

    getFourthClasse(){
      this.classe = this.metierClasses[3]
      this.classNumber = this.metierClasses[3].classe
      this.step = 2
      this.nomClasse = 'Industrie'
      document.getElementById("firstStep").classList.add('checked');
      document.getElementById("testup").classList.add('widthFirst');
    },

    getFiveClasse(){
      this.classe = this.metierClasses[4]
      this.classNumber = this.metierClasses[4].classe
      this.step = 2
      this.nomClasse = 'Construction'
      document.getElementById("firstStep").classList.add('checked');
      document.getElementById("testup").classList.add('widthFirst');
    },

    disabledBeforeToday(date) {
      const today = new Date();
      return date < today;
    },

    disabledAfterToday(date){
      const today = new Date()
      return date > today
    },

    dateDiff: function () {
      if (this.dateEffet === '' && this.duree === '') this.dateEcheance = '';
      let inter = dayjs(this.dateEffet).add(1, 'year').format('YYYY-MM-DD');
      this.dateEcheance = dayjs(inter).add(-1, 'day').format('YYYY-MM-DD')
    },

    calculTTC (){
      if(this.pack == 'basic'){
        this.ttc = (this.prixNetTotal + this.frais + this.taxe)
      }else if(this.pack == 'confort'){
        if(this.nbreAdulteFemme <= 0){
          this.ttc = (this.prixNetTotal + this.frais + this.taxe)
        }else if(this.nbreAdulteFemme > 0){
          if(this.maternite){
            this.ttc = (this.totalHorsTaxe + this.frais + this.taxe)
          }else {
            this.ttc = (this.prixNetTotal + this.frais + this.taxe)
          }
        }
      }else if(this.pack == 'essentiel') {
        if(this.maternite || this.fraisOptique || this.fraisDentaire){
          this.ttc = (this.totalHorsTaxe + this.frais + this.taxe)
        }else {
          this.ttc = (this.prixNetTotal + this.frais + this.taxe)
        }
      }
    },

    calculPrimeHorsTaxe(){
      this.totalHorsTaxe = this.prixNetTotal + this.prixTotalOptions
    },
    calculPrimeTTC (){
      this.PrimeTTC =  this.PrimeNette + this.taxe + this.frais
    },

    calculTaxe(){
        this.taxe = (this.PrimeNette + this.frais) * 0.1
    },

    /*=============Filtre sans le + ni lettre sur les champs de type number ===========*/
    onlyNumber($event) {
      let NumOnly = ($event.NumOnly ? $event.NumOnly : $event.which);
      if ((NumOnly < 48 || NumOnly > 57) && NumOnly !== 46) {
        $event.preventDefault();
      }
    },

    // fonction pour formattage de Date (:-)
    DateFormater: function (TheDate) {
      if (TheDate) {
        return dayjs(TheDate).format("DD-MM-YYYY");
      }
    },

    /*===Send of data to API allowing create proposition for the customer===*/
    CreateDevisIndividu: function() {
      if (!store.state.isUserLoggedIn) {
        this.showLoginForm = true
      } else {
        if(this.dateEffet && this.dateEffet!=null && this.dateEcheance && this.dateEcheance!=null )
        {
          const Individuel = {
            userid:store.state.user._id,
            createur:store.state.user._id,
            branche:"Individuel accident",
            assureurs:"AXA",
            Contractor : this.ContractantFields,
            Classe : this.classe,
            CapitalDeces : this.capitalDeces,
            CapitalInvalidite : this.capitalInvalidite,
            garanties: this.garanties,
            Bourse : this.bourse,
            BourseIncapacite : this.bourseIncapacite,
            bourseIncapaciteTemporaire :  this.bourseIncapaciteTemporaire,
            BourseFraisMedicaux : this.bourseFraisMedicaux,
            PrimeDeces : this.Prime_deces,
            PrimeInvalidite : this.prime_invalidite,
            surprimes:this.SurprimeNette,
            MontantNet: this.PrimeNette,
            dateEffet: this.dateEffet,
            plateforme:"Front",
            dateEcheance: this.dateEcheance,
            dateSouscription: dayjs(new Date()).format('YYYY-MM-DD'),
          };

          this.disabledButtonValidate = true
          this.dialogLoading = true;
          Api().post('individuelaccident/add', Individuel)
              .then((result) => {
                Api().get('devis/' + result.data.devis._id)
                    .then(response => {
                      this.$store.dispatch('setDevisPayement', response.data);
                       this.dialogLoading = false, this.disabledButtonValidate = false, this.$router.push('/payement') 
                       
                    })
              }).catch((err) => {
                console.log(err)
              })
        }else{
          this.$toasted.show("Date d'effet et date d'échéance obligatoires !", this.ToastTabError)
        }
      }
    },

    /*============= Fonction pour calculer la date 1ere mise en circulation ===========*/
    yearsDiff() {
      const date1 = dayjs(this.dateCircule);
      const date2 = dayjs(new Date().toISOString().substr(0, 10));
      let daydiff = date2.diff(date1, 'days');
      this.age = daydiff;

      if (this.age < 0) {
        this.age = null;
        this.annee_mois = '';
        this.$toasted.show('Erreur, date antérieure à la date actuelle! ', this.ToastTabError)
        this.dateCircule = null

      } else if (this.age >= 360) {
        let year = Math.floor(this.age / 360);
        this.age = year;
        this.annee = year;
        this.year = this.age;
        this.an = this.annee_mois = 'an(s)'
      }

    },


    isMobile: function () {
      if (screen.width <= 760) {
        return true
      } else {
        return false
      }
    },

    isTablette() {
      if (screen.width > 425 && screen.width <= 768) {
        return true
      } else {
        return false
      }
    },

    isDesktop: function () {
      if (screen.width > 768) {
        return true
      } else {
        return false
      }
    },

  },

  computed: {
    progressClasses() {
      let result = 'progress '
      if (this.currentStep && this.currentStep.label === 'complete') {
        return result += 'progress--complete'
      }
      return result += `progress--${this.steps.indexOf(this.currentStep) + 1}`
    },

    formTitle() {
      return this.editedIndex === -1 ? 'Nouveau véhicule' : 'Modification du véhicule'
    },

    /*=================proprieté permettant de selectionner touts les assureurs à la fois ==============*/
    selectAll: {
      get: function () {
        return this.listeAssureurs ? this.selected.length == this.listeAssureurs.length : false;
      },
      set: function (value) {
        const assureurs = [];

        if (value) {
          this.listeAssureurs.forEach(function (assure) {
            assureurs.push(assure.societe);
          });
        }
        this.assureurs = assureurs;
      }
    }
  },

  watch: {
    dialog(val) {
      val || this.close()
    },

    model(val) {
      if (typeof val == 'object') {
        this.model = val.Type
      } else if (typeof val == 'string') {
        this.model = val
      }
    },

    showLoginForm(val) {
      if (val == false) {
        if (store.state.isUserLoggedIn) {
          this.proprietaire = this.$store.state.user.prenom + ' ' + this.$store.state.user.nom
        }
      }
    }
  },

  created() {
    this.fraisMedicaux = FraisMedicaux
    this.capitalList = Capitaux
  },

  mounted: function () {
    window.scrollTo(0, 0);
    this.checkToken()
    this.getListeBourse()
    this.getListeCapitaux()
    this.getListeClass()
    esk('track', 'Conversion');

    (function () {
      "use strict";
      const jQueryPlugin = (window.jQueryPlugin = function (ident, func) {
        return function (arg) {
          if (this.length > 1) {
            this.each(function () {
              const $this = $(this);

              if (!$this.data(ident)) {
                $this.data(ident, func($this, arg));
              }
            });

            return this;
          } else if (this.length === 1) {
            if (!this.data(ident)) {
              this.data(ident, func(this, arg));
            }

            return this.data(ident);
          }
        };
      });
    })();

    (function () {
      "use strict";
      function Guantity($root) {
        const element = $root;
        const quantity = $root.first("data-quantity");
        let quantity_target = $root.find("[data-quantity-target]");
        let quantity_minus = $root.find("[data-quantity-minus]");
        let quantity_plus = $root.find("[data-quantity-plus]");
        let quantity_ = quantity_target.val();
        $(quantity_minus).click(function () {
          quantity_target.val(--quantity_);
        });
        $(quantity_plus).click(function () {
          quantity_target.val(++quantity_);
        });
      }
      $.fn.Guantity = jQueryPlugin("Guantity", Guantity);
      $("[data-quantity]").Guantity();
    })();

    // eslint-disable-next-line no-undef
    $(document).ready(function(){
      $('button').click(function(e){
        let button_classes, value = +$('.counter').val();
        button_classes = $(e.currentTarget).prop('class');
        if(button_classes.indexOf('up_count') !== -1){
          value = (value) + 1;
        } else {
          value = (value) - 1;
        }
        value = value < 0 ? 0 : value;
        $('.counter').val(value);
      });
      $('.counter').click(function(){
        $(this).focus().select();
      });
    });
  }
}
</script>

<style lang="less" scoped>
@import "../assets/css/button.css";
@import "../assets/css/devis_css.css";
@import "../assets/css/assurcare/form_assurcare.css";

body::-webkit-scrollbar {
  display: none!important; /* for Chrome, Safari, and Opera */
}

/*.scroll {
  //width: 500px;
  height: 310px;
  overflow-x: hidden;
  overflow-y: hidden;
}*/

.scrolling {
  -ms-overflow-style: none; /* for Internet Explorer, Edge */
  scrollbar-width: none; /* for Firefox */
  overflow-y: scroll;
}

.scrolling::-webkit-scrollbar {
  display: none; /* for Chrome, Safari, and Opera */
}

/* other styling */
.scrolling {
  border-radius: 5px;
  height: 350px;
}

.card_width {
  width:170px!important
}
.img_margin_top {
  margin-top : -57%!important;
}
.to-left {
  text-align: left;
}

::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
  font-size: 15px;
}
.form {
  background-color: #fff;
  padding: 1.5rem;
  border-radius: 15px!important;
}

.form .page {
  height: auto;
}

button.next {
  position: absolute;
  bottom: 0;
  right: 0;
  margin-right: 1.5rem;
  margin-bottom: 1rem;
}

button.previous {
  position: absolute;
  bottom: 0;
  left: 0;
  margin-left: 1.5rem;
  margin-bottom: 1rem;
}


button.edit {
  position: absolute;
  bottom: 0;
  right: 0;
}

h4 {
  color: #29323a;
  margin-bottom: 15px;
  font-weight: 600;
}

html {
  background-color: #1a1a1a;
  overflow: hidden;
}
.middle {
  width: auto;
  text-align: center;
  /* Made by */
}
.middle h1 {
  font-family: "Inter", sans-serif;
  color: #fff;
}
.middle input[type="radio"] {
  display: none;
}
.middle input[type="radio"]:checked + .box {
  background-color: rgba(255, 164, 9, 0.07);
  transition: all .33s ease;
  border: 2px solid #ffa409;
  color: #29323a;
}
.middle input[type="radio"]:checked + .box span {
  color: #29323a;
  transform: translateY(70px);
}
.middle input[type="radio"]:checked + .box span:before {
  transform: translateY(0px);
  opacity: 1;
}
.middle .box {
  width: 220px;
  height: 150px;
  border-radius: 12px;
  background-color: #fff;
  transition: all 250ms ease;
  will-change: transition;
  display: inline-block;
  text-align: center;
  cursor: pointer;
  position: relative;
  box-shadow: 0 4px 8px rgb(172 186 200 / 10%);
  font-size: 10px;
  border: 1px solid #d9dee3;
  font-family: Open Sans,sans-serif;
  font-weight: 900;
}
.middle .box:hover {
  background-color: rgba(255, 164, 9, 0.07);
  transition: all .33s ease;
  border: 2px solid #ffa409;
}
.middle .box:hover span {
  color: #29323a;
}

.middle .box:active {
  transform: translateY(10px);
}
.middle .box span {
  position: absolute;
  transform: translate(0, 60px);
  left: 0;
  right: 0;
  padding-top: 15%;
  transition: all 300ms ease;
  font-size: 1.5em;
  user-select: none;
  color: #29323a;
}
.middle .box span:before {
  font-size: 1.2em;
  font-family: FontAwesome;
  display: block;
  transform: translateY(-80px);
  opacity: 0;
  transition: all 300ms ease-in-out;
  font-weight: normal;
  color: #fff;
}
.middle p {
  color: #fff;
  font-family: "Inter", sans-serif;
  font-weight: 400;
}
.middle p a {
  text-decoration: underline;
  font-weight: bold;
  color: #fff;
}
.middle p span:after {
  content: "\f0e7";
  font-family: FontAwesome;
  color: yellow;
}

.widthFirst{
  background-color: var(--custom-color-primary)!important;
  height: 5px;
  border-radius: 5px;
  transition: width .33s ease;
  width:24.11112%;
}
.widthSecond{
  background-color: var(--custom-color-primary)!important;
  height: 5px;
  border-radius: 5px;
  transition: width .33s ease;
  width:50%;
}
.widthThirt{
  background-color: var(--custom-color-primary)!important;
  height: 5px;
  border-radius: 5px;
  transition: width .33s ease;
  width:75%;
}
.widthFour{
  background-color: var(--custom-color-primary)!important;
  height: 5px;
  border-radius: 5px;
  transition: width .33s ease;
  width:100%;
}

.paralax-cover-image {
  background-image: url('../assets/img/assurance/sante.jpg');
  position: relative;
  background-size: contain!important;
  background-position: 50%;
  min-height: 230px;
  width: 100%;
  margin: 0 0 0;
  display: flex;
  /*padding: 20px;*/
  align-items: center;
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  -moz-align-items: center;
  -ms-align-items: center;

}
.paralax-cover-image p {
  color: rgb(255, 255, 255);
  font-size: 20px;
  font-weight: 300;
}

.paralax-cover-image .paralax-cover-image-text,
.paralax-cover-image h2 {
  color: #fff;
  font-size: 2em;
  line-height: 1.25;
  z-index: 1;
  margin-bottom: 0;
  max-width: 610px;
  text-align: center;
  margin-left: 8.5%;
}

.paralax-cover-image.has-background-dim:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.5);
}
.paralax-cover-image {
  background-attachment: fixed;
  background-position: 50% 80px;
}



.paralax-cover-image_mobile {
  background-image: url('../assets/img/assurance/sante_mobile.jpg');
  position: relative;
  background-size: contain;
  background-position: 50%;
  min-height: 150px;
  width: 100%;
  margin: 0 0 0;
  display: flex;
  //padding: 20px;
  align-items: center;
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  -moz-align-items: center;
  -ms-align-items: center;

}
.paralax-cover-image_mobile p {
  color: rgb(255, 255, 255);
  font-size: 20px;
  font-weight: 300;
  padding-bottom: 20Px;
}

.paralax-cover-image_mobile .paralax-cover-image-text_mobile,
.paralax-cover-image_mobile h2 {
  color: #fff;
  font-size: 2em;
  line-height: 1.25;
  z-index: 1;
  margin-bottom: 0;
  max-width: 610px;
  text-align: center;
  margin-left: 8.5%;
}

.paralax-cover-image_mobile.has-background-dim_mobile:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.5);
}
.paralax-cover-image_mobile {
  // background-attachment: fixed;
  background-position: 100% 40px;
}


.hero {
  position: relative;
  background-size: cover;
  background-position: center center;
  height: 680px;
  min-height: 320px;
  max-height: 100%;
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  -moz-align-items: center;
  -ms-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  -moz-justify-content: center;
  -ms-justify-content: center;
  justify-content: center;
  -ms-flex-pack: center;
  padding: 20px;
}
.hero .content_home {
  position: relative;
  min-height: 280px;
  width: 100%;
  margin-left: 8.5%;
  z-index: 2;
  /*//background: red;*/
}
.hero .content_home p {
  color: rgb(255, 255, 255);
  font-size: 20px;
  font-weight: 300;
  width: 100%;
  max-width: 100%;
  margin-left: auto;
  margin-right: auto;
}


/*== start of code for tooltips ==*/
.tool {
  cursor: help;
  position: relative;
}


/*== common styles for both parts of tool tip ==*/
.tool::before,
.tool::after {
  left: 50%;
  opacity: 0;
  position: absolute;
  z-index: -100;
}

.tool:hover::before,
.tool:focus::before,
.tool:hover::after,
.tool:focus::after {
  opacity: 1;
  transform: scale(1) translateY(0);
  z-index: 100;
}


/*== pointer tip ==*/
.tool::before {
  border-style: solid;
  border-width: 1em 0.75em 0 0.75em;
  border-color: #565C61 transparent transparent transparent;
  bottom: 100%;
  content: "";
  margin-left: -0.5em;
  transition: all .65s cubic-bezier(.84,-0.18,.31,1.26), opacity .65s .5s;
  transform:  scale(.6) translateY(-90%);
}

.tool:hover::before,
.tool:focus::before {
  transition: all .65s cubic-bezier(.84,-0.18,.31,1.26) .2s;
}


/*== speech bubble ==*/
.tool::after {
  background: #565C61;
  border-radius: .25em;
  bottom: 176%;
  color: #EDEFF0;
  font-size:15px;
  content: attr(data-tip);
  margin-left: -8.75em;
  padding: 1em;
  transition: all .65s cubic-bezier(.84,-0.18,.31,1.26) .2s;
  transform:  scale(.6) translateY(50%);
  width: 17.5em;

}

.tool:hover::after,
.tool:focus::after  {
  transition: all .65s cubic-bezier(.84,-0.18,.31,1.26);
}

@media (max-width: 760px) {
  .tool::after {
    font-size: .75em;
    margin-left: -5em;
    width: 10em;
  }
}



.muted{
  font-size: 15px;
  margin-left: 2px;
}
.main {
  margin-left: 5px;
}
main_prix{
  margin-left: 10px;
  width: 100px;
}

.new_counter {
  width: 45px;
  border-radius: 0px !important;
  text-align: center;
}
.up_count {
  margin-bottom: 10px;
  margin-left: -4px;
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
  color: #ffa409;
}
.down_count {
  margin-bottom: 10px;
  margin-right: -4px;
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
  color: #ffa409;
}


.souscrip_switch input[type="radio"] {
  display: none;
}
.souscrip_switch label {
  position: relative;
  display: inline-block;
  padding: 3px 3px 3px 20px;
  cursor: pointer;
  font-size: 15px;
}
.souscrip_switch label::before,
.souscrip_switch label::after {
  position: absolute;
  content: '';
  top: 50%;
  border-radius: 100%;
  -webkit-transition: all .2s;
  transition: all .2s;
}
.souscrip_switch label::before {
  left: 0;
  width: 14px;
  height: 14px;
  margin-top: -8px;
  background: #f3f3f3;
  border: 1px solid #ccc;
}
.souscrip_switch label:hover::before {
  background: #fff;
}
.souscrip_switch label::after {
  opacity: 0;
  left: 4px;
  width: 8px;
  height: 8px;
  margin-top: -4px;
  background: #ffa409;
  -webkit-transform: scale(2);
  transform: scale(2);
}
.souscrip_switch input[type="radio"]:checked + label::before {
  background: #fff;
  border: 1px solid #ffa409;
}
.souscrip_switch input[type="radio"]:checked + label::after {
  opacity: 1;
  -webkit-transform: scale(1);
  transform: scale(1);
}







.toggle {
  position: relative;
  width: 82px;
  height: 35px;
  border: 3px solid #f9f9f9;
  border-radius: 40px;
}

.toggle input[type="checkbox"] {
  opacity: 0;
  cursor: pointer;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10;
  width: 84px;
  height: 34px;
}

.toggle .btn {
  display: block;
  position: absolute;
  z-index: 4;
  top: -3px;
  left: -1px;
  width: 37px;
  height: 37px;
  background: #F5F5F5;
  border: 1px solid #e8e8e8;
  border-radius: 100%;
  box-shadow: 0 2px 4px rgba(100, 100, 100, 0.1);
  transition: left .25s ease-in-out;
}

.toggle input[type="checkbox"]:checked ~ .btn {
  left: 44px;
}

.toggle .texts {
  position: absolute;
  top: 9px;
  z-index: 2;
  width: 100%;
  font-family: 'Lato', Helvetica, sans-serif;
  font-weight: bold;
  color: #fff;
  text-transform: uppercase;
  font-size: 14px;
}

.toggle .texts:before {
  content: "Oui";
  position: absolute;
  left: 10px;
}

.toggle .texts:after {
  content: "No";
  position: absolute;
  right: 8px;
}

.toggle .bg {
  display: block;
  background: #F56557;
  position: absolute;
  z-index: 0;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 40px;
  box-shadow: inset 0 0px 2px 1px rgba(0, 0, 0, 0.3);
  transition: background .25s ease-in;
}

.toggle input[type="checkbox"]:checked ~ .bg {
  background: #48C893;
}

.to-right {
  float: right!important;
}






/*== start of code for tooltips ==*/
.tool {
  cursor: help;
  position: relative;
}


/*== common styles for both parts of tool tip ==*/
.tool::before,
.tool::after {
  left: 50%;
  opacity: 0;
  position: absolute;
  z-index: -100;
}

.tool:hover::before,
.tool:focus::before,
.tool:hover::after,
.tool:focus::after {
  opacity: 1;
  transform: scale(1) translateY(0);
  z-index: 10000;
}


/*== pointer tip ==*/
.tool::before {
  border-style: solid;
  border-width: 1em 0.75em 0 0.75em;
  border-color: #565C61 transparent transparent transparent;
  bottom: 100%;
  content: "";
  margin-left: -0.5em;
  transition: all .65s cubic-bezier(.84,-0.18,.31,1.26), opacity .65s .5s;
  transform:  scale(.6) translateY(-90%);
}

.tool:hover::before,
.tool:focus::before {
  transition: all .65s cubic-bezier(.84,-0.18,.31,1.26) .2s;
}


/*== speech bubble ==*/
.tool::after {
  background: #565C61;
  border-radius: .25em;
  bottom: 176%;
  color: #EDEFF0;
  font-size:15px;
  content: attr(data-tip);
  margin-left: -8.75em;
  padding: 1em;
  transition: all .65s cubic-bezier(.84,-0.18,.31,1.26) .2s;
  transform:  scale(.6) translateY(50%);
  width: 17.5em;

}

.tool:hover::after,
.tool:focus::after  {
  transition: all .65s cubic-bezier(.84,-0.18,.31,1.26);
}

@media (max-width: 760px) {
  .tool::after {
    font-size: .75em;
    margin-left: -5em;
    margin-right: -5em;
    width: 10em;
  }
}







.card {
  background-color: #fff;
  width: 240px;;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border-radius: 2rem;
  box-shadow: 0px 1rem 1.5rem rgba(0,0,0,0.1)!important;
}
.card .banner {
  background: #FAFAFA;
  //height: 6rem;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  box-sizing: border-box;
}
.card .banner .svg {
  background-color: #fff;
  //width: 8rem;
  //height: 8rem;
  box-shadow: 0 0.5rem 1rem rgba(0,0,0,0.1);
  border-radius: 50%;
  transform: translateY(50%);
  transition: transform 200ms cubic-bezier(0.18, 0.89, 0.32, 1.28);
  float: left;
}
.card:hover {
  transform: translateY(0.1%) scale(1);
}
.card .menu {
  width: 100%;
  height: 5.6rem;
  padding: 1rem;
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
  position: relative;
  box-sizing: border-box;
}
.card .menu .opener {
  width: 2.5rem;
  height: 2.5rem;
  position: relative;
  border-radius: 50%;
  transition: background-color 100ms ease-in-out;
}
.card .menu .opener:hover {
  background-color: #f2f2f2;
}
.card .menu .opener span {
  background-color: #404040;
  width: 0.4rem;
  height: 0.4rem;
  position: absolute;
  top: 0;
  left: calc(50% - 0.2rem);
  border-radius: 50%;
}
.card .menu .opener span:nth-child(1) {
  top: 0.45rem;
}
.card .menu .opener span:nth-child(2) {
  top: 1.05rem;
}
.card .menu .opener span:nth-child(3) {
  top: 1.65rem;
}
.card h2.name {
  text-align: center;
  padding: 0 2rem 0.5rem;
  margin: 0;
  color: #ffa409;
}
.card .title {
  color: #a0a0a0;
  font-size: 0.85rem;
  text-align: center;
  padding: 0 2rem 1.2rem;
}
.card .actions {
  padding: 0 2rem 1.2rem;
  display: flex;
  flex-direction: column;
  order: 99;
}
.card .actions .follow-info {
  padding: 0 0 1rem;
  display: flex;
}
.card .actions .follow-info h2 {
  text-align: center;
  width: 40%;
  margin: 0;
  box-sizing: border-box;
}
.card .actions .follow-info h2 a {
  text-decoration: none;
  padding: 0.8rem;
  display: flex;
  flex-direction: column;
  border-radius: 0.8rem;
  transition: background-color 100ms ease-in-out;
}
.card .actions .follow-info h2 a span {
  color: #1c9eff;
  font-weight: bold;
  transform-origin: bottom;
  transform: scaleY(1.3);
  transition: color 100ms ease-in-out;
}
.card .actions .follow-info h2 a small {
  color: #afafaf;
  font-size: 0.85rem;
  font-weight: normal;
}
.card .actions .follow-info h2 a:hover {
  background-color: #f2f2f2;
}
.card .actions .follow-info h2 a:hover span {
  color: #007ad6;
}






/*  Toggle Switch  */

.toggleSwitch span span {
  display: none;
}

.toggleSwitch {
  display: inline-block;
  height: 18px;
  position: relative;
  overflow: visible;
  padding: 0;
  margin-left: 30px;
  cursor: pointer;
  width: 40px
}
.toggleSwitch * {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}
.toggleSwitch label,
.toggleSwitch > span {
  line-height: 20px;
  height: 20px;
  vertical-align: middle;
}
.toggleSwitch input:focus ~ a,
.toggleSwitch input:focus + label {
  outline: none;
}
.toggleSwitch label {
  position: relative;
  z-index: 3;
  display: block;
  width: 100%;
}
.toggleSwitch input {
  position: absolute;
  opacity: 0;
  z-index: 5;
}
.toggleSwitch > span {
  position: absolute;
  left: -50px;
  width: 100%;
  margin: 0;
  padding-right: 50px;
  text-align: left;
  white-space: nowrap;
}
.toggleSwitch > span span {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 5;
  display: block;
  width: 50%;
  margin-left: 50px;
  text-align: left;
  font-size: 1em;
  width: 100%;
  left: 15%;
  top: -1px;
  opacity: 0;
}
.toggleSwitch a {
  position: absolute;
  right: 50%;
  z-index: 4;
  display: block;
  height: 100%;
  padding: 0;
  left: 2px;
  width: 18px;
  background-color: #fff;
  border: 1px solid #CCC;
  border-radius: 100%;
  -webkit-transition: all 0.2s ease-out;
  -moz-transition: all 0.2s ease-out;
  transition: all 0.2s ease-out;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}
.toggleSwitch > span span:first-of-type {
  color: #ccc;
  opacity: 1;
  left: 45%;
}
.toggleSwitch > span:before {
  content: '';
  display: block;
  width: 100%;
  height: 100%;
  position: absolute;
  left: 50px;
  top: -2px;
  background-color: #fafafa;
  border: 1px solid #ccc;
  border-radius: 30px;
  -webkit-transition: all 0.2s ease-out;
  -moz-transition: all 0.2s ease-out;
  transition: all 0.2s ease-out;
}
.toggleSwitch input:checked ~ a {
  border-color: #fff;
  left: 100%;
  margin-left: -8px;
}
.toggleSwitch input:checked ~ span:before {
  border-color: #ffa409;
  box-shadow: inset 0 0 0 30px #ffa409;
}
.toggleSwitch input:checked ~ span span:first-of-type {
  opacity: 0;
}
.toggleSwitch input:checked ~ span span:last-of-type {
  opacity: 1;
  color: #fff;
}

.healthCard-product{
  background: #ffffff;
  padding:15px;
  border-radius:6px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
  position:relative;
  margin:20px auto;
}
.healthCard-img{
  position:absolute;
  top: -10px;
  left:50%;
  transform:translate(-50%);
  -webkit-transform:translate(-50%);
  -ms-transform:translate(-50%);
  -moz-transform:translate(-50%);
  -o-transform:translate(-50%);
  -khtml-transform:translate(-50%);
  width: 100%;
  padding: 15px;
  transition: all 0.2s ease-in-out;
}
.healthCard-img img{
  width:100%;
  transition: all 0.2s ease-in-out;
  border-radius:6px;
}
.healthCard-text{
  padding-top:68%;
}
.healthCard-text .category{
  text-align:center;
  font-size:12px;
  font-weight:bold;
  padding:5px;
  margin-bottom:45px;
  position:relative;
  transition: all 0.2s ease-in-out;
}
.healthCard-text .category > *{
  position:absolute;
  top:50%;
  left:50%;
  transform: translate(-50%,-50%);
  -webkit-transform: translate(-50%,-50%);
  -moz-transform: translate(-50%,-50%);
  -ms-transform: translate(-50%,-50%);
  -o-transform: translate(-50%,-50%);
  -khtml-transform: translate(-50%,-50%);

}
.healthCard-text .category > span{
  width: max-content;
  padding: 12px 30px;
  border: 1px solid #ffa409;
  background:#ffa409;
  color:#fff;
  box-shadow: 0 19px 38px rgba(0,0,0,0.30), 0 15px 12px rgba(0,0,0,0.22);
  border-radius:27px;
  transition: all 0.05s ease-in-out;

}
.healthCard-text .category > .button_redirect {
  width: -webkit-max-content!important;
  display: inline-block!important;
  padding: 12px 30px;
  border: 1px solid #ffa409;
  background:#ffa409;
  color:#fff;
  box-shadow: 0 19px 38px rgba(0,0,0,0.30), 0 15px 12px rgba(0,0,0,0.22);
  border-radius:27px;
  transition: all 0.05s ease-in-out;
}

.healthCard-text .category > .button_redirect_disabled {
  width: -webkit-max-content!important;
  display: inline-block!important;
  padding: 12px 30px;
  border: 1px solid #59595B;
  background:#59595B;
  color:#fff;
  box-shadow: 0 19px 38px rgba(0,0,0,0.30), 0 15px 12px rgba(0,0,0,0.22);
  border-radius:27px;
  transition: all 0.05s ease-in-out;
}

.healthCard-product:hover .healthCard-text .category > span{
  border-color:#ddd;
  box-shadow: none;
  padding: 11px 28px;
}
.healthCard-text .title-product h3{
  font-size:20px;
  font-weight:bold;
  margin:15px auto;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  width:100%;
}
.healthCard-text .description-prod p{
  margin:0;
}
.healthCard-text .description-prod {
  width: 100%;
  //height:130px;
  -webkit-line-clamp: 3;
  -webkit-box-orienthealthCard-img: vertical;
  margin-bottom:15px;
}

@media screen and (max-width: 991px) {
  .healthCard-product{
    margin:40px auto;
  }
  .healthCard-product .healthCard-img{
    top:-40px;
  }
  .healthCard-product .healthCard-img img{
    box-shadow: 0 19px 38px rgba(0,0,0,0.30), 0 15px 12px rgba(0,0,0,0.22);
  }
  .healthCard-product .healthCard-text .category > span{
    border-color:#ddd;
    box-shadow: none;
    padding: 11px 28px;
  }
  .healthCard-product .healthCard-text .category{
    margin-top: -55px;
  }
}

// css du loader
.loading-state {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  
}
.loading {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 5px solid #ddd;
  border-top-color: #ffa409;
  animation: loading 1s linear infinite;
}
@keyframes loading {
  to {
    transform: rotate(360deg);
  }
}
.loading-text{
    color: rgb(255, 255, 255);
    font-weight: bold;
}
</style>
